import { Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { DatabaseService } from '../../../services/database.service';
import { CommonModule } from '@angular/common'; // 匯入 CommonModule
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // 匯入 FormsModule
import { DecimalPipe } from '@angular/common';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop'; // 導入拖放模組
import { DragDropModule } from '@angular/cdk/drag-drop';
import { HttpClient, HttpParams } from '@angular/common/http';

// import { EnvironmentService } from '../../../services/enviroment.service';
// import { environment } from '../../../services/global-environment';;

import { environment } from '../../../services/global-environment';
import { ContentObserver } from '@angular/cdk/observers';
import { finalize, retry } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router'; // 新增這行
import { LawUpdateAndCompareComponent } from '../law-update-and-compare/law-update-and-compare.component';
import { I18nService } from '../../../services/i18n.service';
import { TopicTagsResponse } from '../../../models/api-response.model';
import { FormTagsComponent } from '../../items/form-tags.component';
import { EmailService } from '../../../services/email.service';

interface TopicItem {
  topic: string;
}

type LawFieldKey =
  | 'law_name'
  | 'law_publish_date'
  | 'law_modified_date'
  | 'type'
  | 'law_hierarchy'
  | 'law_url';

interface LawDatabaseItem {
  lawName: string;
  date: string;
  source?: string;
  Source?: string;
  lawUrl: string;
  laws?: {
    law_articles?: Array<{
      article_id?: string;
      article_type: string;
      article_no: string;
      article_content: string;
    }>;
    law_modified_date?: string;
    [key: string]: any; // laws 中的其他屬性
  };
  [key: string]: any; // 允許其他頂層屬性
}

// Define the interface for the text parse response
interface LawTextParseResponse {
  success?: boolean;
  laws?: {
    law_name?: string;
    law_publish_date?: string;
    law_modified_date?: string;
    law_category?: string;
    law_articles: Array<{
      article_type: string;
      article_no: string;
      article_content: string;
    }>;
    metadata?: any;
  };
  message?: string;
  requestId?: string;
  error?: string;
  suggestion?: string;
}

interface CompanyOption {
  id: string;
  name: string;
}

@Component({
  selector: 'app-regulation-list',
  standalone: true,
  imports: [CommonModule, FormsModule, DecimalPipe, DragDropModule, LawUpdateAndCompareComponent, FormTagsComponent], // 加入 CommonModule 和 FormsModule
  templateUrl: './regulation-list.component.html',
  styleUrls: ['./regulation-list.component.scss'], // 修改 styleUrl 為 styleUrls 並更新檔案名稱
})
export class RegulationListComponent implements OnInit {
  @Input() companyId: string = ''; // 外部傳入的 companyId

  isLoadingRegulations: boolean = false;
  isUpdatingTopic: boolean = false;
  isDeletingTopic: boolean = false;
  isAssigningTask: boolean = false; // 指派任務 loading 狀態
  // 編輯清單下拉與 Dialog 控制
  showEditListDropdown: boolean = false;
  showEditTopicDialog: boolean = false;
  showDeleteTopicDialog: boolean = false;
  currentTopicName: string = '';
  newTopicName: string = '';
  topicToDelete: string = '';
  confirmDeleteText: string = '';

  regulations: any[] = []; // 用於存放過濾後的資料
  uniqueTopics: string[] = []; // 存放唯一的 topic 值
  uniqueTypesWithCounts: { type: string; count: number }[] = []; // 存放唯一的 type 和對應的法規數量
  selectedTopic: string = ''; // 當前選中的 topic
  selectedType: string = ''; // 當前選中的 type
  topicTags: string[] = []; // 當前 topic 下的所有標籤
  filteredLaws: any[] = []; // 根據篩選條件顯示的 laws
  allLaws: any[] = [];

  // 排序狀態管理
  currentSortField: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';
  sortableFields = ['type', 'law_hierarchy', 'law_name', 'relevance', 'law_tags', 'law_modified_date'] as const;
  isPopupVisible = false; // 控制彈窗顯示
  selectedLaw: any = null; // 儲存選中的法規資訊
  selectedLawArticles: any[] = []; // 儲存選中的法條內容
  tags: string[] = [
    '1@gmail.com',
    '2@gmail.com',
    '3@gmail.com',
    '4@gmail.com',
    '5@gmail.com',
    '6@gmail.com',
    '7@gmail.com',
    '8@gmail.com',
    '9@gmail.com',
  ];
  selectedTags: string[] = []; // 已選擇的信箱
  availableEmails: string[] = [
    '1@gmail.com',
    '2@gmail.com',
    '3@gmail.com',
    '4@gmail.com',
    '5@gmail.com',
    '6@gmail.com',
    '7@gmail.com',
    '8@gmail.com',
    '9@gmail.com',
  ]; // 可用的信箱
  newTag: string = ''; // 新輸入的信箱
  showDropdown: boolean = false; // 控制下拉選單顯示

  // 部門相關屬性
  departments: string[] = [
    '人力資源部',
    '資訊部',
    '財務部',
    '法務部',
    '營運部',
    '研發部',
    '行銷部',
    '客服部',
  ];
  selectedDepartments: string[] = [];
  filteredDepartments: string[] = [];
  deptInput: string = '';
  showDeptDropdown: boolean = false;

  // 鑑別群組多選下拉
  missionGroups: string[] = [];
  selectedGroups: string[] = [];
  showGroupDropdown: boolean = false;

  // 部門成員資料快取
  departmentMembersCache: { [departmentId: string]: any[] } = {};
  loadingDepartmentMembers: Set<string> = new Set();

  // 用於關閉群組下拉選單的外部點擊監聽
  @ViewChild('groupDropdown', { static: false }) groupDropdownRef!: ElementRef;

  private groupDropdownClickListener: any;

  // 追蹤當前鍵盤選中的部門索引
  activeIndex: number = -1; // -1 表示沒有選中項

  // 添加新的屬性
  showAddDropdown = false;
  showAutoAddPopup = false;
  newRegulation: any = {
    type: '',
    law_name: '',
    law_url: '',
    law_modified_date: new Date().toISOString().substring(0, 10),
    law_hierarchy: '',
    law_index: '',
    relevance: '參考',
    penalties: '',
    articleCount: 0,
    articles: [],
  };

  showArticlePreview = false;

  // 添加屬性來控制批次設定下拉選單的顯示
  showBatchDropdown: boolean = false;

  // 添加以下屬性到 RegulationListComponent 類中
  showTaskAssignmentDialog: boolean = false;
  taskTitle: string = '';
  selectedLawCount: number = 0;
  involvedDepartmentCount: number = 0;

  // 在組件中添加控制面板收合的屬性和方法
  isPanelCollapsed = false;

  lastscandate: string = ''; // 最後掃描日期

  // 法規更新與比較相關屬性
  showLawUpdateCompare: boolean = false;
  currentLawForUpdate: any = null;

  // 鑑別群組多選下拉相關方法
  isGroupSelected(group: string): boolean {
    return this.selectedGroups.includes(group);
  }

  toggleGroupSelection(group: string, event: Event): void {
    event.stopPropagation();
    const idx = this.selectedGroups.indexOf(group);
    if (idx > -1) {
      this.selectedGroups.splice(idx, 1);
    } else {
      this.selectedGroups.push(group);
      // 取得部門成員資料
      this.loadDepartmentMembers(group);
    }
  }

  toggleGroupDropdown(event: Event): void {
    event.stopPropagation();
    this.showGroupDropdown = !this.showGroupDropdown;

    if (this.showGroupDropdown) {
      // 延遲以確保 ViewChild 綁定
      setTimeout(() => {
        this.addGroupDropdownOutsideClickListener();
      });
    } else {
      this.removeGroupDropdownOutsideClickListener();
    }
  }

  addGroupDropdownOutsideClickListener(): void {
    this.groupDropdownClickListener = (event: MouseEvent) => {
      if (!this.groupDropdownRef) return;
      const dropdownEl = this.groupDropdownRef.nativeElement as HTMLElement;
      if (dropdownEl && !dropdownEl.contains(event.target as Node)) {
        this.showGroupDropdown = false;
        this.removeGroupDropdownOutsideClickListener();
      }
    };
    document.addEventListener('mousedown', this.groupDropdownClickListener, true);
  }

  removeGroupDropdownOutsideClickListener(): void {
    if (this.groupDropdownClickListener) {
      document.removeEventListener('mousedown', this.groupDropdownClickListener, true);
      this.groupDropdownClickListener = null;
    }
  }

  // (Removed duplicate ngOnDestroy)

  togglePanel(): void {
    this.isPanelCollapsed = !this.isPanelCollapsed;
    // 可能需要延遲一下重新調整表格布局
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 300);
  }

  // 欄位設定相關
  showColumnSettings: boolean = false;
  availableColumns: any[] = [
    {
      id: 'checkbox',
      displayName: '勾選框',
      visible: true,
      required: false,
      width: '40px',
      class: 'col-checkbox',
    },
    {
      id: 'version',
      displayName: '版本數',
      visible: false,
      required: false,
      width: '80px',
      class: '',
    },
    {
      id: 'name',
      displayName: '法規名稱',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-name',
    },
    {
      id: 'modifiedDate',
      displayName: '修訂日期',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-date',
    },
    {
      id: 'penalties',
      displayName: '罰鍰與刑責',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-date',
    },
    {
      id: 'relevance',
      displayName: '相關性',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-relevance',
    },
    {
      id: 'code',
      displayName: '法規代碼',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-code',
    },
    {
      id: 'departments',
      displayName: '相關部門',
      visible: true,
      required: false,
      width: '',
      class: 'col-departments',
    },
    {
      id: 'result',
      displayName: '鑑別結果',
      visible: true,
      required: false,
      width: '',
      class: '',
    },
    {
      id: 'type',
      displayName: '分類',
      visible: true,
      required: false,
      width: '',
      class: 'col-type',
    },
    {
      id: 'hierarchy',
      displayName: '層級',
      visible: true,
      required: false,
      width: '',
      class: 'col-level',
    },
  ];

  // 計算可見的欄位
  visibleColumns: any[] = this.availableColumns.filter((col) => col.visible);

  columnsOrderChanged: boolean = false; // 新增屬性來追蹤欄位順序是否已變更

  // 預設欄位
  defaultColumns: any[] = [
    {
      id: 'checkbox',
      displayName: '勾選框',
      visible: true,
      required: false,
      width: '40px',
      class: 'col-checkbox',
    },
    {
      id: 'version',
      displayName: '版本數',
      visible: false,
      required: false,
      width: '80px',
      class: '',
    },
    {
      id: 'name',
      displayName: '法規名稱',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-name',
    },
    {
      id: 'modifiedDate',
      displayName: '修訂日期',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-date',
    },
    {
      id: 'penalties',
      displayName: '罰鍰與刑責',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-date',
    },
    {
      id: 'relevance',
      displayName: '相關性',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-relevance',
    },
    {
      id: 'code',
      displayName: '法規代碼',
      visible: true,
      required: false,
      width: '120px',
      class: 'col-code',
    },
    {
      id: 'departments',
      displayName: '相關部門',
      visible: true,
      required: false,
      width: '',
      class: 'col-departments',
    },
    {
      id: 'result',
      displayName: '鑑別結果',
      visible: true,
      required: false,
      width: '',
      class: '',
    },
    {
      id: 'type',
      displayName: '分類',
      visible: true,
      required: false,
      width: '',
      class: 'col-type',
    },
    {
      id: 'hierarchy',
      displayName: '層級',
      visible: true,
      required: false,
      width: '',
      class: 'col-level',
    },
  ];

  // 添加批次設定法規代碼相關屬性
  showBatchCodeDialog: boolean = false;
  batchCodePrefix: string = '';
  batchCodeStartNumber: number = 1;
  batchCodeDigits: number = 3;

  // 批次設定相關性相關屬性
  showBatchRelevanceDialog: boolean = false;
  batchRelevanceValue: string = '';

  // 批次設定部門相關屬性
  showBatchDepartmentDialog: boolean = false;
  batchDeptUpdateMode: 'replace' | 'add' = 'add'; // 更新模式：取代或追加
  batchSelectedDepartments: string[] = []; // 已選擇的部門
  batchDeptSearchInput: string = ''; // 搜尋輸入
  filteredBatchDepartments: string[] = []; // 過濾後的部門列表
  newBatchDepartment: string = ''; // 新增的批次部門

  // 追蹤修改的資料列
  modifiedLaws: Set<string> = new Set(); // 存储被修改行的 law_id
  hasModifications: boolean = false; // 標記是否有未儲存的修改

  // 原始資料快照，用於恢復
  originalLawsData: Map<string, any> = new Map();

  showSampleSelectionDialog: boolean = false;
  sampleTopics: string[] = [];
  selectedSampleTopic: string = '';
  sampleLaws: any[] = [];
  filteredSampleLaws: any[] = []; // 篩選後的範例法規列表
  selectedSampleLaws: Set<string> = new Set();
  isSampleLoading: boolean = false;
  sampleSearchKeyword: string = ''; // 範例法規搜尋關鍵字
  private isSearchTriggeredByUser: boolean = false; // 防護標識，確保搜尋只在用戶觸發時執行

  typeSelectionMode: string = 'original'; // 'original': 使用原始類型，'existing': 使用既有類型，'new': 建立新類型
  selectedTargetType: string = ''; // 選擇的目標類型
  newTypeName: string = ''; // 新建立的類型名稱

  inlineEditing: boolean = false;
  showInlineDeptInput: boolean = false;
  inlineDeptInput: string = '';
  inlineDeptSuggestions: string[] = [];
  newInlineLaw: any = {
    type: '',
    law_name: '',
    law_url: '',
    law_hierarchy: '命令',
    law_index: '',
    law_modified_date: new Date().toISOString().substring(0, 10),
    relevance: '參考',
    law_tags: [], // 使用 law_tags 替代 departments
    articleCount: 0,
    isLoading: false,
    loadFailed: false,
  };

  // Excel 匯入相關屬性
  showExcelImportDialog = false;
  excelFile: File | null = null;
  excelDataPreview: any[] = [];
  previewRowCount = 5; // 預覽顯示筆數
  totalRowCount = 0; // 總筆數
  dataValidationResults: {
    type: 'error' | 'warning' | 'info';
    message: string;
  }[] = [];
  importProgress = 0;
  importStatus = '';
  isImporting = false;
  hasValidationErrors = false;
  importCompanyId = ''; // 新增: 匯入的公司ID
  importTopic = ''; // 新增: 匯入的主題

  private apiUrl = environment.apiUrl;

  companies: CompanyOption[] = [];
  selectedCompany: string = '';

  excelconveterresult: any[] = [];

  showImportDropdown = false;

  // 用于ISO范例库新增功能的公司和主题选择
  selectedCompanyForSample: string = '';
  selectedTopicForSample: string = '';
  isNewCompany: boolean = false;
  isNewTopic: boolean = false;
  newCompanyName: string = '';
  // newTopicName: string = ''; // 移除重複宣告，沿用 class 既有的 newTopicName

  // Add these properties to the component class
  public isArticleEditMode = false;
  public articlesJsonText = '';
  public jsonError: string | null = null;
  public isArticlesModified = false;

  // PDF Upload dialog properties
  public showPdfUploadDialog = false;
  public pdfFile: File | null = null;
  public pdfModelVersion = 'gpt-4.1-nano';
  public pdfUploadStatus = '';
  public isPdfProcessing = false;
  public pdfProcessSuccess = false;

  // Text parsing dialog properties
  public showTextParseDialog = false;
  public lawTextInput = '';
  public textModelVersion = 'gpt-4.1-nano';
  public textParseStatus = '';
  public isTextProcessing = false;
  public textProcessSuccess = false;

  public isJsonEditMode = true; // 預設使用 JSON 編輯模式
  public editableArticles: any[] = []; // 表單模式下的可編輯法條陣列
  public isFormDataChanged = false; // 記錄表單是否有變更

  public involvedDepartments: string[] = [];
  public taskStartDate: string = '';
  public taskEndDate: string = '';
  public taskNote: string = '';

  // Add this property to your component class
  lawsNeedingContentCount: number = 0;

  // 進階篩選UI控制
  public showAdvancedFilters: boolean = false;

  // 篩選條件
  public dateRangeFilter = {
    start: null as string | null,
    end: null as string | null,
  };

  public relevanceFilter = {
    related: false,
    unrelated: false,
    reference: false,
  };

  public selectedDepartmentFilters: string[] = [];
  public tempDeptFilter: string = '';
  public availableDepartments: string[] = [];

  public isAddingSampleLaws: boolean = false;

  isLawFieldTouched = {
    law_name: false,
    law_publish_date: false,
    law_modified_date: false,
    type: false,
    law_hierarchy: false,
    law_url: false,
  };

  showRelevanceDropdown = false;
  showDepartmentDropdown = false;
  departmentSearchText = '';

  isCheckingChanges = false;

  assistantNo ="";

  constructor(
    private databaseService: DatabaseService,
    private cdr: ChangeDetectorRef,
    private http: HttpClient,
    private route: ActivatedRoute, // 新增這行
    private i18nService: I18nService,
    private emailService: EmailService
  ) {}

  ngOnInit(): void {
    this.companyId = environment.companyid;

    this.loadCompanies();

    // 讀取儲存的欄位設定
    this.initializeColumnSettings();

    // 設置默認的目標類型（如果有類型的話）
    if (this.uniqueTypesWithCounts && this.uniqueTypesWithCounts.length > 0) {
      this.selectedTargetType = this.uniqueTypesWithCounts[0].type;
    }

    document.addEventListener('click', () => {
      this.showImportDropdown = false;
      this.showBatchDropdown = false;
      this.showEditListDropdown = false;
    });

    // 为范例库设置默认值
    this.selectedCompanyForSample = this.selectedCompany || '';
    this.selectedTopicForSample = this.selectedTopic || '';


    //要先取得 assistantNo 才能取得鑑別群組
    this.getassistantNo();


    this.getmissionGroups();



  }



 getassistantNo(){
    // 從 URL 查詢參數中取得 id 的值
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      if (id) {
        this.assistantNo = id;
        console.log('取得 assistantNo:', this.assistantNo);

        // 如果需要在取得 assistantNo 後重新載入鑑別群組，可以呼叫以下方法
        // this.getmissionGroups();
      } else {
        console.warn('URL 中未找到 id 參數');
        // 如果沒有 id 參數，可以設定預設值或顯示錯誤
        this.assistantNo = '';
      }
    });
  }

  //取得鑑別群組
  getmissionGroups(){
    const assistantNo = this.assistantNo; // 根據實際需求調整助手編號
    const url = `${this.apiUrl}/api/departments/${this.companyId}/${assistantNo}`;

    this.http.get<any>(url).subscribe({
      next: (response) => {
        if (response && response.success && response.data) {
          const children = response.data.children || [];
          const departments: string[] = [];

          // 遍歷第一層，取得所有部門

          children.forEach((item: any) => {
            if (item.type === 'department' && item.name) {
              departments.push(item.name);
            }
          });

          this.missionGroups = departments;
          console.log('成功取得鑑別群組（部門）:', this.missionGroups);
        } else {
          this.missionGroups = [];
          console.warn('未取得有效的組織結構資料');
        }
      },
      error: (error) => {
        console.error("取得鑑別群組失敗:", error);
        this.missionGroups = [];
      }
    });
  }

  // 取得部門成員資料
  // 注意：此方法需要後端API支援 GET /api/departments/${companyId}/${assistantNo}/members?departmentName=${departmentName}
  getDepartmentMembers(departmentName: string): Promise<any[]> {
    const url = `${this.apiUrl}/api/departments/${this.companyId}/${this.assistantNo}/members`;
    const params = { departmentName: departmentName };

    return this.http.get<any>(url, { params }).toPromise()
      .then(response => {
        if (response && response.success && response.data && response.data.members) {
          return response.data.members;
        } else {
          console.warn(`部門 ${departmentName} 沒有成員資料`);
          return [];
        }
      })
      .catch(error => {
        console.error(`取得部門 ${departmentName} 成員失敗:`, error);
        // 由於後端API尚未開發，這裡先返回模擬資料
        return this.getMockDepartmentMembers(departmentName);
      });
  }

  // 模擬部門成員資料（後端API開發完成後可移除）
  private getMockDepartmentMembers(departmentName: string): any[] {
    const mockMembers = [
      { id: 'user1', name: '張三', email: 'zhang@example.com', department: departmentName },
      { id: 'user2', name: '李四', email: 'li@example.com', department: departmentName },
      { id: 'user3', name: '王五', email: 'wang@example.com', department: departmentName }
    ];
    console.log(`使用模擬資料：部門 ${departmentName} 的成員`, mockMembers);
    return mockMembers;
  }

  // 發送合規任務指派通知
  private async sendComplianceNotifications(
    taskData: any,
    selectedLaws: any[],
    selectedGroups: string[]
  ): Promise<void> {
    console.log('開始發送合規任務指派通知...');

    let totalSent = 0;
    let totalFailed = 0;

    // 計算總法條數
    const totalArticleCount = selectedLaws.reduce((total, law) => {
      return total + (law.laws?.law_articles?.length || 0);
    }, 0);

    // 為每個選定的部門發送通知
    for (const department of selectedGroups) {
      try {
        // 使用已經快取的部門成員資料
        const members = this.departmentMembersCache[department] || [];

        if (members.length === 0) {
          console.warn(`部門 ${department} 沒有成員資料，跳過通知`);
          continue;
        }

        // 為每個有 email 的成員發送通知
        for (const member of members) {
          // 檢查成員是否有有效的 email
          if (!member.email || member.email.trim() === '') {
            console.warn(`成員 ${member.name} 沒有 email 資料，跳過通知`);
            continue;
          }

          try {
            const taskInfo = {
              taskName: taskData.title,
              regulationCount: selectedLaws.length,
              articleCount: totalArticleCount,
              notes: taskData.note || '',
              startDate: taskData.startDate,
              deadline: taskData.endDate
            };

            await this.emailService.sendComplianceAssignmentNotification(
              member.email,
              member.name,
              taskInfo
            ).toPromise();

            totalSent++;
            console.log(`成功發送通知給 ${member.name} (${member.email})`);
          } catch (error) {
            totalFailed++;
            console.error(`發送通知給 ${member.name} (${member.email}) 失敗:`, error);
          }
        }
      } catch (error) {
        console.error(`處理部門 ${department} 的通知時發生錯誤:`, error);
      }
    }

    console.log(`通知發送完成 - 成功: ${totalSent}, 失敗: ${totalFailed}`);

    // 顯示發送結果
    if (totalSent > 0) {
      alert(`任務指派成功！已發送通知給 ${totalSent} 位成員${totalFailed > 0 ? `，${totalFailed} 位發送失敗` : ''}`);
    } else {
      alert('任務指派成功，但沒有成功發送任何通知');
    }
  }



  // 添加切換導入下拉菜單的方法
  toggleImportDropdown(event: Event): void {
    event.stopPropagation();
    this.showImportDropdown = !this.showImportDropdown;
    // 关闭其他可能打开的下拉菜单
    this.showBatchDropdown = false;
  }

  loadCompanies() {
    this.selectedCompany = this.companyId;

    if (this.selectedCompany) {
      this.companies = [
        {
          // Error: Type '{ id: string; name: string; }' is not assignable to type 'CompanyOption[]'
          id: this.selectedCompany,
          name: this.selectedCompany,
        },
      ];

      console.log('Selected company:', this.selectedCompany);

      // 重新載入該公司的主題列表
      this.loadAllTopics();

      this.loadRegulations();
    } else {
      // Handle the case where no company is selected
      console.warn('No company selected, cannot load company data');
      this.companies = [];
    }
  }

  // 當公司選擇變更時
  onCompanyChange() {
    // 更新當前選中的公司ID
    this.companyId = this.selectedCompany;

    // 重新載入該公司的主題列表
    this.loadAllTopics();

    // 重置主題選擇
    this.selectedTopic = '';

    // 載入該公司的法規
    this.loadRegulations();
  }

  ngOnDestroy(): void {
    // 移除任何可能存在的事件監聽器
    this.removeGroupDropdownOutsideClickListener();
    document.removeEventListener('click', this.closeBatchDropdown);

    // 如果還有其他清理工作，添加在這裡
  }

  // 初始化欄位設定
  initializeColumnSettings() {
    // 先嘗試從 localStorage 讀取設定
    const savedSettings = localStorage.getItem('regulationColumnSettings');

    if (savedSettings) {
      try {
        // 解析保存的設定
        const settings = JSON.parse(savedSettings);

        // 更新可用欄位的可見性和順序
        // 初始化欄位設定 - 僅修改 filter 部分
        if (settings.columns && Array.isArray(settings.columns)) {
          // 使用保存的欄位順序重建 availableColumns
          this.availableColumns = settings.columns
            .map((id: string) => {
              // 查找當前定義中的欄位
              const col = this.defaultColumns.find(
                (c: { id: string }) => c.id === id
              );
              if (col) {
                // 保留原始設置但更新可見性
                const visible = settings.visibleColumns.includes(id);
                return { ...col, visible };
              }
              return null;
            })
            .filter((c: any): c is NonNullable<typeof c> => c !== null); // 為參數 c 添加明確的類型注解
        }
      } catch (e) {
        console.error('載入欄位設定時出錯:', e);
        // 使用默認設定
        this.resetColumnSettings();
        return;
      }
    } else {
      // 沒有保存的設定，使用默認設定
      this.resetColumnSettings();
    }

    // 更新可見欄位列表
    this.updateVisibleColumns();
  }

  // 保存設定到 localStorage
  saveColumnSettingsToStorage() {
    const settings = {
      // 保存完整的欄位順序
      columns: this.availableColumns.map((col) => col.id),
      // 保存可見的欄位 ID
      visibleColumns: this.availableColumns
        .filter((col) => col.visible)
        .map((col) => col.id),
    };

    localStorage.setItem('regulationColumnSettings', JSON.stringify(settings));
  }

  // 重置為默認設定
  resetColumnSettings() {
    // 重設為預設定義的欄位和順序
    this.availableColumns = [...this.defaultColumns];
    this.updateVisibleColumns();
  }

  // 先載入所有法規，獲取唯一主題列表
  loadAllTopics(): void {
    // 顯示載入中狀態

    // 呼叫 API 取得主題列表
    this.http
      .post<any>(`${this.apiUrl}/api/regulation/get_topics`, {
        companyid: this.companyId,
      })
      .subscribe({
        next: (response: any) => {
          // 移除載入中元素

          console.log('Response:', response); // 確認 API 回應

          if (response && response.success) {
            // console.log('主題列表:', response.data);
            // 處理 API 回應取得主題列表
            this.uniqueTopics =
              response.data.map((item: TopicItem) => item.topic) || [];

            // console.log('唯一主題:', this.uniqueTopics);

            // 預設選擇第一個 topic 值
            if (this.uniqueTopics.length > 0) {
              this.selectedTopic = this.uniqueTopics[0];

              // 選擇主題後立即載入此主題的法規
              this.loadRegulations();
            }
          } else {
            console.error('載入主題列表失敗:', response.message || '未知錯誤');
            alert('載入主題列表失敗: ' + (response.message || '未知錯誤'));
            this.uniqueTopics = [];
          }
        },
        error: (err) => {
          // 移除載入中元素

          console.error('Failed to load topics:', err);

          // 處理特定錯誤類型並顯示適當訊息
          let errorMessage = '載入主題列表失敗，請稍後再試';

          if (err.status === 400) {
            errorMessage = '請求參數錯誤';
          } else if (err.status === 401 || err.status === 403) {
            errorMessage = '您沒有權限存取此資料';
          } else if (err.status === 429) {
            errorMessage = '請求過於頻繁，請稍後再試';
          }

          alert(errorMessage);
        },
      });
  }

  // 根據選中的 topic 載入法規
  loadRegulations(): void {
    // 如果沒有選中的 topic，則不載入數據
    if (!this.selectedTopic) {
      this.filteredLaws = [];
      this.topicTags = [];
      return;
    }

    // 同時載入法規和標籤
    this.loadTopicTags();

    const params = new HttpParams()
      .set('companyid', this.companyId)
      .set('topic', this.selectedTopic);

    this.isLoadingRegulations = true; // 顯示載入中狀態

    this.http
      .post<any>(`${this.apiUrl}/api/regulation/load_law_list`, {
        companyid: this.companyId,
        topic: this.selectedTopic,
      })
      .subscribe({
        next: (response: any) => {
          console.log(response);

          if (response && response.success) {
            this.regulations = response.data || [];

            // 為每個法規計算法條數量，只計算 article_type 為 "A" 的法條
            this.regulations = this.regulations.map((item) => {
              if (item.laws && item.laws.law_articles) {
                // 過濾出 article_type 為 "A" 的法條並計算數量
                const typeAArticles = item.laws.law_articles.filter(
                  (article: { article_type: string }) =>
                    article.article_type === 'A'
                );
                item.laws.articleCount = typeAArticles.length;
              } else {
                item.laws.articleCount = 0;
              }
              return item;
            });

            this.extractUniqueValues(); // 更新唯一的 type 值

            // 如果沒有選中的 type，則預設選擇 "ALL"
            if (!this.selectedType) {
              this.selectedType = 'ALL';
            }

            // 最後篩選並設置 filteredLaws
            this.filterByTopic();

            // 計算需要載入法條的法規數量
            this.calculateLawsNeedingContent();

            // 初始化數據時保存原始快照
            this.filteredLaws.forEach((law) => {
              this.originalLawsData.set(law.law_id, {
                law_index: law.law_index,
                relevance: law.relevance,
                law_tags: this.ensureArray(law.law_tags),
                law_url: law.law_url,
                law_hierarchy: law.law_hierarchy, // 添加層級到原始資料中
                ScanDate: law.ScanDate, // 添加掃描日期到原始資料中
                ScanResult: law.ScanResult, // 添加掃描結果到原始資料中
              });
            });

            console.log('this.filteredLaws:', this.filteredLaws);


            this.allLaws = this.filteredLaws;


            this.loadAvailableDepartments();

            this.isLoadingRegulations = false;
          } else {
            console.error('載入查核清單失敗:', response.message || '未知錯誤');
            alert('載入查核清單失敗：' + (response.message || '未知錯誤'));
            this.regulations = [];
            this.filteredLaws = [];
            this.lawsNeedingContentCount = 0; // 重設計數
          }
          this.isLoadingRegulations = false;
        },
        error: (err) => {
          console.error('Failed to load regulations:', err);
          this.isLoadingRegulations = false;
        },
      });
  }

  // 載入當前 topic 下的所有標籤
  loadTopicTags(): void {
    if (!this.selectedTopic) {
      this.topicTags = [];
      return;
    }

    // 確保 companyId 存在
    if (!this.companyId) {
      console.error('Company ID is required to load topic tags');
      this.topicTags = [];
      return;
    }

    this.databaseService.getTopicTags(this.companyId, this.selectedTopic).subscribe({
      next: (response: TopicTagsResponse) => {
        if (response && response.success) {
          this.topicTags = response.data || [];
          console.log('Topic tags loaded:', this.topicTags);
        } else {
          console.error('Failed to load topic tags:', response.message || '未知錯誤');
          this.topicTags = [];
        }
      },
      error: (err) => {
        console.error('Error loading topic tags:', err);
        this.topicTags = [];

        // 處理特定錯誤類型
        let errorMessage = '載入標籤失敗';
        if (err.response) {
          if (err.response.status === 404) {
            errorMessage = '該主題不存在或沒有相關標籤';
          } else if (err.response.status === 500) {
            errorMessage = '伺服器錯誤，請稍後再試';
          } else {
            errorMessage = `載入標籤失敗: ${err.response.data?.message || err.response.statusText}`;
          }
        } else if (err.code === 'NETWORK_ERROR') {
          errorMessage = '網路連接錯誤，請檢查網路狀態';
        }
        console.warn(errorMessage);
      },
    });
  }

  // 提取唯一的 topic 和 type 值，並計算每個 type 的法規數量
  extractUniqueValues(): void {
    // this.uniqueTopics = [
    //   ...new Set(this.regulations.map((item) => item.topic)),
    // ];

    const types = Array.from(new Set(this.regulations.map((item) => item.type)));
    this.uniqueTypesWithCounts = types.map((type) => ({
      type,
      count: this.regulations.filter((item) => item.type === type).length,
    }));
  }

  // 根據選中的 topic 篩選，並處理相關、無關、參考欄位
  filterByTopic(): void {
    const filteredByTopic = this.selectedTopic
      ? this.regulations.filter((item) => item.topic === this.selectedTopic)
      : this.regulations;

    // console.log('Filtered by Topic:', filteredByTopic);

    // 如果選擇了 ALL，則不進行 type 篩選
    this.filteredLaws = filteredByTopic
      .filter(
        (item) => this.selectedType === 'ALL' || item.type === this.selectedType
      )
      .map((item) => {
        const law = item.laws;
        return {
          ...law,
          type: item.type, // 添加 type 屬性
          id: item.id, //添加id欄位
          related: item.results?.related === 'V' ? true : false,
          unrelated: item.results?.unrelated === 'V' ? true : false,
          reference: item.results?.reference === 'V' ? true : false,
          isEditingCode: false, // 法規代碼編輯狀態
          isEditingSource: false, // 添加法規來源編輯狀態
          isEditingHierarchy: false, // 添加法規層級編輯狀態
          law_articles: Array.isArray(law?.law_articles)
            ? law.law_articles
            : [], // 確保是數組
          law_tags: this.ensureArray(law.law_tags), // 使用輔助方法確保 law_tags 是陣列
          deptInput: '', // 部門輸入
          showDeptInput: false, // 是否顯示部門輸入框
          showDeptDropdown: false, // 是否顯示下拉選單
          filteredDepartments: [], // 過濾後的部門
          activeIndex: -1, // 當前鍵盤選擇的部門索引
          currentSuggestion: '', // 當前建議
          ScanDate: item.ScanDate || '', // 添加掃描日期
          ScanResult: item.ScanResult || '', // 添加掃描結果
        };
      })
      .sort((a, b) => this.sortData(a, b));

    console.log('Filtered Laws2:', this.filteredLaws);

    this.calculateLawsNeedingContent();

   // 使用排序法找出最大日期
var scanDates = this.filteredLaws
  .map(law => law.ScanDate)
  .filter(date => date); // 過濾掉無效值

// 如果有日期資料則排序找出最大值
var lastestScanDate = '';
if (scanDates.length > 0) {
  scanDates.sort((a, b) => {
    return new Date(b).getTime() - new Date(a).getTime(); // 降序排列
  });
  lastestScanDate = scanDates[0]; // 最大日期值
}

    this.updatelastscandate(lastestScanDate);
  }



    updatelastscandate(date: string) {
    // 更新最後掃描日期
    this.lastscandate = date;
  }

  // 修改 showDeptInputForLaw 方法來在一開始就顯示部門列表
  showDeptInputForLaw(law: any, event: Event): void {
    event.stopPropagation();
    law.showDeptInput = true;

    // 確保 law_tags 初始化為陣列
    if (!law.law_tags) {
      law.law_tags = [];
    } else if (!Array.isArray(law.law_tags)) {
      law.law_tags = [law.law_tags];
    }
  }

  // 隱藏部門輸入框
  hideDeptInputForLaw(law: any): void {
    law.showDeptInput = false;
  }

  // 處理法規標籤變更
  onLawTagsChange(law: any, tags: string[]): void {
    console.log('onLawTagsChange called with tags:', tags);

    // 儲存更新後的標籤
    law.law_tags = tags || [];
    this.markLawAsModified(law.id || law.law_id);

    // 直接檢查標籤是否已存在於 topicTags 中，不需比較 previousTags
    const tagsToAdd = (tags || []).filter(tag => !this.topicTags.includes(tag));

    console.log('New tags to add to topicTags:', tagsToAdd);

    if (tagsToAdd.length > 0) {
      // 將新標籤添加到 topicTags
      tagsToAdd.forEach(newTag => {
        if (newTag) {
          this.topicTags.push(newTag);
        }
      });

      // 對 topicTags 進行排序以保持一致性
      this.topicTags.sort();

      console.log('更新標籤列表，新增標籤:', tagsToAdd);
    }
  }

  onInlineLawTagsChange(tags: string[]): void {
    const previousTags = this.newInlineLaw.law_tags || [];
    this.newInlineLaw.law_tags = tags || [];

    // 檢查是否有新增的標籤，並將其添加到 topicTags 中
    const newTags = (tags || []).filter(tag => !previousTags.includes(tag));
    if (newTags.length > 0) {
      newTags.forEach(newTag => {
        if (newTag && !this.topicTags.includes(newTag)) {
          this.topicTags.push(newTag);
        }
      });

      // 對 topicTags 進行排序以保持一致性
      this.topicTags.sort();

      console.log('更新內聯法規標籤列表，新增標籤:', newTags);
    }
  }

  // 修改添加部門到法規的方法
  addDepartmentToLaw(law: any): void {
    // 檢查輸入是否為空
    if (law.deptInput && law.deptInput.trim() !== '') {
      const newTag = law.deptInput.trim();

      // 初始化 law_tags 為陣列（如果不存在）
      if (!law.law_tags) {
        law.law_tags = [];
      } else if (!Array.isArray(law.law_tags)) {
        // 如果 law_tags 不是陣列，則將其轉換為陣列
        law.law_tags = [law.law_tags];
      }

      // 直接添加用戶輸入的值
      law.law_tags.push(newTag);

      // 將新標籤添加到 topicTags 中
      if (!this.topicTags.includes(newTag)) {
        this.topicTags.push(newTag);
        this.topicTags.sort();
        console.log('通過直接輸入新增標籤到列表:', newTag);
      }

      // 記錄修改
      this.markLawAsModified(law.id);

      // 清空輸入
      law.deptInput = '';

      // 不關閉輸入框，允許連續添加
    } else {
      this.hideDeptInputForLaw(law);
    }
  }

  // 修改 onDeptInputChangeForLaw 方法，使其在輸入為空時也顯示部門建議
  onDeptInputChangeForLaw(law: any, event: any): void {
    const input = law.deptInput?.toLowerCase() || '';

    // 當輸入為空時，顯示所有部門
    if (input.trim() === '') {
      law.filteredDepartments = [...this.departments];

      // 如果有部門，選中第一個並顯示建議
      if (law.filteredDepartments.length > 0) {
        law.activeIndex = 0;
        law.currentSuggestion = law.filteredDepartments[0];
      } else {
        law.activeIndex = -1;
        law.currentSuggestion = '';
      }
      return;
    }

    // 搜尋包含輸入文字的部門
    law.filteredDepartments = this.departments.filter((dept) =>
      dept.toLowerCase().includes(input)
    );

    // 排序：優先顯示前綴匹配的部門
    law.filteredDepartments.sort((a: string, b: string): number => {
      const aStartsWithInput: boolean = a.toLowerCase().startsWith(input);
      const bStartsWithInput: boolean = b.toLowerCase().startsWith(input);

      if (aStartsWithInput && !bStartsWithInput) return -1;
      if (!aStartsWithInput && bStartsWithInput) return 1;
      return 0;
    });

    // 如果找到匹配的，選擇第一個作為建議
    if (law.filteredDepartments && law.filteredDepartments.length > 0) {
      const bestMatch = law.filteredDepartments[0];

      // 只有當是前綴匹配時才顯示建議補全
      if (bestMatch.toLowerCase().startsWith(input)) {
        law.currentSuggestion = bestMatch.substring(input.length);
      } else {
        law.currentSuggestion = '';
      }

      law.activeIndex = 0; // 默認選中第一個
    } else {
      law.currentSuggestion = '';
      law.activeIndex = -1;
    }
  }

  // 用 Tab 鍵完成建議
  completeWithSuggestion(law: any, event: Event): void {
    if (
      law.currentSuggestion &&
      law.filteredDepartments &&
      law.filteredDepartments.length > 0 &&
      law.activeIndex >= 0
    ) {
      event.preventDefault();

      // 獲取當前選中的部門
      const selectedDept = law.filteredDepartments[law.activeIndex];
      if (selectedDept) {
        // 更新輸入值為完整部門名稱
        law.deptInput = selectedDept;

        // 如果是空輸入，在自動完成後清除建議，但保留選中項
        if (law.deptInput.trim() === '') {
          law.currentSuggestion = '';
        } else {
          // 清除建議
          law.currentSuggestion = '';
        }
      }
    }
  }

  // 修改 handleKeyDownForLaw 方法，改進上下方向鍵選擇功能
  handleKeyDownForLaw(law: any, event: KeyboardEvent): void {
    // 處理 Tab 鍵自動完成
    if (event.key === 'Tab' && law.currentSuggestion) {
      event.preventDefault();
      if (
        law.filteredDepartments &&
        law.filteredDepartments.length > 0 &&
        law.activeIndex >= 0
      ) {
        law.deptInput = law.filteredDepartments[law.activeIndex];
        law.currentSuggestion = '';
      }
      return;
    }

    // 處理上下鍵選擇
    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault(); // 防止光標移動

      if (!law.filteredDepartments || law.filteredDepartments.length === 0) {
        return;
      }

      // 更新當前選中項
      if (event.key === 'ArrowDown') {
        law.activeIndex =
          (law.activeIndex + 1) % law.filteredDepartments.length;
      } else {
        law.activeIndex =
          law.activeIndex <= 0
            ? law.filteredDepartments.length - 1
            : law.activeIndex - 1;
      }

      // 空白輸入時直接顯示完整部門名稱
      if (law.deptInput === '') {
        law.currentSuggestion = law.filteredDepartments[law.activeIndex];
        return;
      }

      // 更新建議顯示
      const selectedDept = law.filteredDepartments[law.activeIndex];
      const input = law.deptInput.toLowerCase();

      if (selectedDept.toLowerCase().startsWith(input)) {
        // 顯示自動完成建議
        law.currentSuggestion = selectedDept.substring(law.deptInput.length);
      } else {
        // 如果不是前綴匹配，不顯示建議
        law.currentSuggestion = '';
      }
    }
  }

  // 選擇部門
  selectDepartmentForLaw(law: any, dept: string, event: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!law.law_tags) {
      law.law_tags = [];
    }

    if (!law.law_tags.includes(dept)) {
      law.law_tags.push(dept);
      this.markLawAsModified(law.id);
    }

    // 重置
    law.deptInput = '';
    law.currentSuggestion = '';
    law.showDeptDropdown = false;
  }

  // 修改從法規中移除部門的方法
  removeDepartmentFromLaw(law: any, index: number, event: Event): void {
    event.stopPropagation();

    // 確保 law_tags 是陣列
    if (
      law.law_tags &&
      Array.isArray(law.law_tags) &&
      index >= 0 &&
      index < law.law_tags.length
    ) {
      law.law_tags.splice(index, 1);
      this.markLawAsModified(law.id);
    }
  }

  // 選擇 type 並篩選
  selectType(type: string): void {
    this.selectedType = type;
    this.filterByTopic();
  }

  // 打開彈出視窗，顯示法規資訊和法條內容
  openArticlePopup(law: any): void {
    console.log('openArticlePopup', law);

    this.selectedLaw = law; // 設定選中的法規資訊
    this.selectedLawArticles = law.law_articles || []; // 設定選中的法條內容
    this.isPopupVisible = true;
  }

  // 關閉彈出視窗
  closePopup(): void {
    this.isPopupVisible = false;
    this.isArticleEditMode = false; // 關閉時自動回到檢視模式
    this.selectedLaw = null;
    this.selectedLawArticles = [];
    this.isFormDataChanged = false;

    (Object.keys(this.isLawFieldTouched) as LawFieldKey[]).forEach((key) => {
      this.isLawFieldTouched[key] = false;
    });
  }

  // 開始編輯相關性
  editRelevance(law: any): void {
    law.isEditing = true;
  }

  // 儲存相關性
  saveRelevance(law: any): void {
    law.isEditing = false;
    console.log(`已更新相關性為: ${law.relevance}`);
    this.markLawAsModified(law.id);
  }

  // 處理相關性按鈕點擊
  setRelevance(law: any, value: string): void {
    // 設置新的相關性值
    // 先更新顯示的相關性值
    law.relevance = value;

    // 確保 law.results 物件存在
    if (!law.results) {
      law.results = {
        related: null,
        unrelated: null,
        reference: null,
      };
    }

    // 先將所有結果設為 null
    law.results.related = null;
    law.results.unrelated = null;
    law.results.reference = null;

    // 根據 value 來設置正確的 item 為 'V'
    if (value === 'related') {
      law.results.related = 'V';
    } else if (value === 'unrelated') {
      law.results.unrelated = 'V';
    } else if (value === 'reference') {
      law.results.reference = 'V';
    }

    // 標記此法規已修改
    this.markLawAsModified(law.id);
  }

  // 開始編輯法規代碼
  editCode(law: any): void {
    law.isEditingCode = true;
  }

  // 儲存法規代碼
  saveCode(law: any, showAlert: boolean = true): void {
    // 取消編輯模式
    law.isEditingCode = false;
    this.markLawAsModified(law.id);
  }

  // 新增 Tag
  addTag(): void {
    const trimmedTag = this.newTag.trim();
    if (trimmedTag && !this.selectedTags.includes(trimmedTag)) {
      this.selectedTags.push(trimmedTag);
      this.newTag = '';
      this.updateAvailableEmails();
    }
    this.showDropdown = false; // 隱藏下拉選單
  }

  // 選擇信箱
  selectEmail(email: string): void {
    if (!this.selectedTags.includes(email)) {
      this.selectedTags.push(email);
      this.updateAvailableEmails();
    }
    this.newTag = '';
    this.showDropdown = false;
    this.cdr.detectChanges(); // 手動觸發變更檢測
  }

  // 移除 Tag
  removeTag(index: number): void {
    this.selectedTags.splice(index, 1);
    this.updateAvailableEmails();
  }

  // 更新可用的信箱
  updateAvailableEmails(): void {
    this.availableEmails = this.tags.filter(
      (email) => !this.selectedTags.includes(email)
    );
  }

  // 新增查核人員到法條
  addTagToArticle(article: any): void {
    const trimmedTag = article.newTag?.trim();
    if (trimmedTag && !article.selectedTags?.includes(trimmedTag)) {
      article.selectedTags = article.selectedTags || [];
      article.selectedTags.push(trimmedTag);
      article.newTag = '';
    }
    article.showDropdown = false; // 隱藏下拉選單
  }

  // 選擇信箱到法條
  selectEmailForArticle(article: any, email: string): void {
    if (!article.selectedTags?.includes(email)) {
      article.selectedTags = article.selectedTags || [];
      article.selectedTags.push(email);
    }
    article.newTag = '';
    article.showDropdown = false; // 隱藏下拉選單
  }

  // 移除法條中的查核人員
  removeTagFromArticle(article: any, index: number): void {
    article.selectedTags.splice(index, 1);
  }

  // 計算所有類型的法規總數
  getTotalLawsCount(): number {
    return this.uniqueTypesWithCounts.reduce(
      (total, type) => total + type.count,
      0
    );
  }

  /**
   * 計算所有法規的法條總數
   * @returns 法條總數
   */
  getTotalArticlesCount(): number {
    if (!this.regulations || this.regulations.length === 0) {
      return 0;
    }

    let totalCount = 0;

    // 遍歷所有法規
    for (const regulation of this.regulations) {
      if (regulation.laws && regulation.laws.articleCount) {
        totalCount += regulation.laws.articleCount;
      }
    }

    return totalCount;
  }

  // 輸入事件處理
  onDeptInputChange(event: any): void {
    const value = event.target.value;

    // 重置 activeIndex
    this.activeIndex = -1;

    // 當輸入 # 時，顯示所有未選擇的部門
    if (value === '#') {
      this.filteredDepartments = this.departments.filter(
        (dept) => !this.selectedDepartments.includes(dept)
      );
      this.showDeptDropdown = true;
    }
    // 當輸入 #+ 其他字符時，過濾匹配的部門
    else if (value.startsWith('#')) {
      const searchTerm = value.substring(1).toLowerCase();
      this.filteredDepartments = this.departments.filter(
        (dept) =>
          !this.selectedDepartments.includes(dept) &&
          dept.toLowerCase().includes(searchTerm)
      );
      this.showDeptDropdown = true;
    } else {
      this.showDeptDropdown = false;
    }
  }

  // 選擇部門
  selectDepartment(dept: string): void {
    if (!this.selectedDepartments.includes(dept)) {
      this.selectedDepartments.push(dept);
    }
    this.deptInput = '';
    this.showDeptDropdown = false;
    this.activeIndex = -1; // 重置 activeIndex
  }

  // 添加部門（按 Enter 鍵）
  addDepartment(): void {
    if (this.deptInput.startsWith('#')) {
      const deptName = this.deptInput.substring(1);
      if (
        deptName &&
        !this.selectedDepartments.includes(deptName) &&
        this.departments.includes(deptName)
      ) {
        this.selectedDepartments.push(deptName);
      }
    }
    this.deptInput = '';
    this.showDeptDropdown = false;
  }

  // 移除部門
  removeDepartment(index: number): void {
    this.selectedDepartments.splice(index, 1);
  }

  // 處理鍵盤事件
  handleKeyDown(event: KeyboardEvent): void {
    // 如果下拉選單沒有顯示或沒有部門可選，則不處理
    if (!this.showDeptDropdown || this.filteredDepartments.length === 0) {
      return;
    }

    switch (event.key) {
      case 'ArrowDown':
        // 向下鍵，選擇下一個部門
        event.preventDefault(); // 防止光標移動
        this.activeIndex = Math.min(
          this.activeIndex + 1,
          this.filteredDepartments.length - 1
        );
        break;

      case 'ArrowUp':
        // 向上鍵，選擇上一個部門
        event.preventDefault(); // 防止光標移動
        this.activeIndex = Math.max(this.activeIndex - 1, 0);
        break;

      case 'Enter':
        // Enter 鍵，選擇當前高亮的部門
        if (
          this.activeIndex >= 0 &&
          this.activeIndex < this.filteredDepartments.length
        ) {
          this.selectDepartment(this.filteredDepartments[this.activeIndex]);
          event.preventDefault(); // 防止表單提交
        } else {
          this.addDepartment(); // 如果沒有選中項，使用原有的添加方法
        }
        break;

      case 'Escape':
        // Escape 鍵，關閉下拉選單
        this.showDeptDropdown = false;
        this.activeIndex = -1;
        break;
    }
  }

  formatArticleContent(text: string): string {
    if (!text) return '';

    // 檢查文本是否已經包含換行符
    if (text.includes('\n')) {
      // 文本中已經有換行符，直接返回原始文本
      return text;
    } else {
      // 原文沒有換行符，添加格式化處理
      // 在「：」或「。」後添加換行符
      const formattedText = text.replace(/([：。])/g, '$1\n');
      return formattedText;
    }
  }

  toggleAllCheckboxes(event: any): void {
    const isChecked = event.target.checked;
    this.filteredLaws.forEach((law) => (law.selected = isChecked));
  }

  /**
   * Get all selected laws
   */
  getSelectedLaws(): any[] {
    return this.filteredLaws.filter((law) => law.selected);
  }

  // 檢查是否有選中的項目
  hasSelectedItems(): boolean {
    return this.filteredLaws?.some((law) => law.selected) || false;
  }

  // 新增法規
  addNewRegulation(): void {
    // 導航到新增法規頁面或打開新增法規對話框
    console.log('新增法規');
    // 實現具體的新增法規邏輯
  }

  // 全自動新增法規
  addNewRegulationAuto(): void {
    // 預設選擇當前類型
    this.newRegulation.type =
      this.selectedType === 'ALL' ? '' : this.selectedType;

    // 重置表單
    this.newRegulation.law_name = '';
    this.newRegulation.law_url = '';
    this.newRegulation.law_modified_date = new Date()
      .toISOString()
      .substring(0, 10);
    this.newRegulation.law_hierarchy = '';
    this.newRegulation.law_index = '';
    this.newRegulation.relevance = '參考';
    this.newRegulation.penalties = '';
    this.newRegulation.articles = [];

    // 顯示彈窗
    this.showAutoAddPopup = true;
    this.showAddDropdown = false;
  }

  // 關閉全自動新增法規彈窗
  closeAutoAddPopup(): void {
    this.showAutoAddPopup = false;
  }

  // 自動取得法規內容

  // 更新表單內容
  private updateRegulationForm(data: any): void {
    if (data) {
      try {
        // 處理法規基本資訊 (Laws 物件)
        if (data.Laws) {
          this.newRegulation.law_name = data.Laws.LawName || '';
          this.newRegulation.law_modified_date =
            data.Laws.LawModifiedDate || '';
          this.newRegulation.law_hierarchy = data.Laws.LawHierarchy || '';
          this.newRegulation.law_index = data.Laws.LawKey || '';
        }

        // 處理法條內容 (LawArticles 陣列)
        if (data.LawArticles && Array.isArray(data.LawArticles)) {
          // 轉換成應用程式使用的格式
          interface RawArticle {
            ArticleType: string;
            ArticleNo: string;
            ArticleContent: string;
          }

          const articles: {
            article_type: string;
            article_no: string;
            article_content: string;
          }[] = data.LawArticles.map((article: RawArticle) => ({
            article_type: article.ArticleType,
            article_no: article.ArticleNo,
            article_content: article.ArticleContent,
          }));

          this.newRegulation.articles = articles;

          // 計算正式法條(A)的數量
          const articleCount = articles.filter(
            (a) => a.article_type === 'A'
          ).length;
          this.newRegulation.articleCount = articleCount;

          // 顯示法條預覽
          this.showArticlePreview = true;
        }

        alert('法規內容爬取成功！');
      } catch (error) {
        console.error('處理爬取資料時發生錯誤:', error);
        alert('處理法規資料時發生錯誤，請檢查資料格式');
      }
    }
  }

  // 從法規資料庫挑選
  addNewRegulationFromList(): void {
    // 打開全螢幕指派查核任務對話框
    this.showTaskAssignmentDialog = true;
    this.taskTitle = '';

    // 防止頁面滾動
    document.body.style.overflow = 'hidden';

    // 每次開啟時重新計算選中的法規和涉及的部門
    this.calculateSummary();
  }

  // 計算摘要資訊
  calculateSummary(): void {
    // 獲取選中的法規
    const selectedLaws = this.getSelectedLaws();

    // 收集所有涉及的部門（去重）
    const allDepartments = new Set<string>();
    selectedLaws.forEach((law) => {
      if (Array.isArray(law.law_tags)) {
        law.law_tags.forEach((dept: string) => allDepartments.add(dept));
      }
    });

    // 將資訊存儲到組件屬性中，供模板使用
    this.selectedLawCount = selectedLaws.length;
    this.involvedDepartmentCount = allDepartments.size;
    this.involvedDepartments = Array.from(allDepartments); // <--- 加這行
  }

  // 關閉指派查核任務對話框
  closeTaskAssignmentDialog(): void {
    this.showTaskAssignmentDialog = false;

    // 恢復頁面滾動
    document.body.style.overflow = 'auto';
  }

  // 提交指派查核任務
  submitTaskAssignment(): void {
    if (this.isAssigningTask) {
      return;
    }
    if (!this.taskTitle.trim()) {
      alert('請輸入查核主題');
      return;
    }
    if (!this.taskStartDate) {
      alert('請選擇執行開始日期');
      return;
    }
    if (!this.taskEndDate) {
      alert('請選擇截止日期');
      return;
    }
    if (this.selectedGroups.length === 0) {
      alert('請至少選擇一個鑑別群組');
      return;
    }
    const selectedLaws = this.getSelectedLaws();
    if (selectedLaws.length === 0) {
      alert('請至少選擇一筆法規');
      return;
    }

    const processedLaws = selectedLaws.map((law) =>
      this.createLawUpdateData(law)
    );

    console.log('Processed Laws for Submission:', processedLaws);

    // 準備提交的數據
    const taskData = {
      companyid: this.companyId,
      topic: this.selectedTopic,
      title: this.taskTitle,
      startDate: this.taskStartDate,
      endDate: this.taskEndDate,
      note: this.taskNote,
      departments: this.selectedGroups,
      laws: processedLaws,
      savetodb: 'Y',
    };

    console.log('Task Data to Submit:', taskData);

    this.isAssigningTask = true;
    this.http
      .post(`${this.apiUrl}/api/law_check_list/generate_check_list`, taskData)
      .subscribe({
        next: async (response: any) => {
          console.log('查核清單建立成功:', response);

          // 在成功建立查核清單後，發送郵件通知
          try {
            // 保持 loading 狀態，等待郵件發送完成
            await this.sendComplianceNotifications(taskData, selectedLaws, this.selectedGroups);
          } catch (error) {
            console.error('發送郵件通知時發生錯誤:', error);
            // 即使郵件發送失敗，也不影響主流程
            alert('任務指派成功，但郵件通知發送失敗，請手動通知相關人員');
          } finally {
            // 無論郵件發送成功或失敗，都要結束 loading 狀態
            this.isAssigningTask = false;
          }

          this.closeTaskAssignmentDialog();

          // 清除所有選中狀態
          this.filteredLaws.forEach((law) => (law.selected = false));
        },
        error: (error) => {
          this.isAssigningTask = false;
          console.error('查核清單建立失敗:', error);
          alert('查核任務指派失敗，請稍後再試');
        },
      });
  }

  // 切換下拉菜單顯示
  toggleAddDropdown(event: Event): void {
    event.stopPropagation();
    this.showAddDropdown = !this.showAddDropdown;

    // 點擊其他位置時關閉下拉菜單
    if (this.showAddDropdown) {
      setTimeout(() => {
        document.addEventListener('click', this.closeDropdown);
      });
    }
  }

  // 關閉下拉菜單的方法
  closeDropdown = (): void => {
    this.showAddDropdown = false;
    document.removeEventListener('click', this.closeDropdown);
    this.cdr.detectChanges(); // 需要注入 ChangeDetectorRef
  };

  // 切換批次設定下拉選單
  toggleBatchDropdown(event: Event): void {
    // 防止事件冒泡，避免點擊按鈕同時觸發外部點擊事件
    event.stopPropagation();

    // 如果沒有選擇項目，不執行任何操作
    if (!this.hasSelectedItems()) {
      return;
    }

    // 切換下拉選單顯示狀態
    this.showBatchDropdown = !this.showBatchDropdown;

    // 當打開批次設定選單時，確保關閉其他可能打開的選單（如新增法規選單）
    if (this.showBatchDropdown) {
      this.showAddDropdown = false;
    }

    // 添加點擊外部區域關閉下拉選單的事件監聽
    if (this.showBatchDropdown) {
      setTimeout(() => {
        document.addEventListener('click', this.closeBatchDropdown);
      }, 0);
    } else {
      document.removeEventListener('click', this.closeBatchDropdown);
    }
  }

  // 關閉批次設定下拉選單的處理器（需要綁定 this）
  closeBatchDropdown = (event: Event) => {
    // 關閉下拉選單
    this.showBatchDropdown = false;
    document.removeEventListener('click', this.closeBatchDropdown);

    // 因為此方法在 Angular 區域外被調用，需要手動觸發變更檢測
    this.cdr.detectChanges();
  };

  // 批次設定相關性
  batchSetRelevance(): void {
    this.showBatchRelevanceDialog = true;
    this.showBatchDropdown = false; // 關閉下拉選單
    this.batchRelevanceValue = ''; // 重置選擇
  }

  // 關閉批次設定相關性對話框
  closeBatchRelevanceDialog(): void {
    this.showBatchRelevanceDialog = false;
  }

  // 選擇批次相關性值
  selectBatchRelevance(value: string): void {
    this.batchRelevanceValue = value;
  }

  // 套用批次相關性設定
  applyBatchRelevance(): void {
    if (!this.batchRelevanceValue) {
      return;
    }

    const selectedLaws = this.filteredLaws.filter((law) => law.selected);
    if (selectedLaws.length === 0) {
      this.closeBatchRelevanceDialog();
      return;
    }

    // 為每個選中的法規設定相關性
    for (const law of selectedLaws) {
      law.relevance = this.batchRelevanceValue;
      this.markLawAsModified(law.id);
    }

    // 顯示成功提示
    alert(
      `已成功為 ${selectedLaws.length} 個法規設定相關性為「${this.batchRelevanceValue}」`
    );
    this.closeBatchRelevanceDialog();
  }

  // 批次設定相關部門
  batchSetDepartments(): void {
    this.showBatchDepartmentDialog = true;
    this.showBatchDropdown = false; // 關閉下拉選單

    // 初始化預設值
    this.batchDeptUpdateMode = 'add';
    this.batchSelectedDepartments = [];
    this.batchDeptSearchInput = '';

    // 初始化顯示所有部門
    this.filteredBatchDepartments = [...this.departments];
  }

  // 關閉批次設定部門對話框
  closeBatchDepartmentDialog(): void {
    this.showBatchDepartmentDialog = false;
  }

  // 過濾批次部門列表
  filterBatchDepartments(): void {
    const searchTerm = this.batchDeptSearchInput.toLowerCase().trim();

    if (!searchTerm) {
      this.filteredBatchDepartments = [...this.departments];
      return;
    }

    this.filteredBatchDepartments = this.departments.filter((dept) =>
      dept.toLowerCase().includes(searchTerm)
    );
  }

  // 切換部門選擇狀態
  toggleBatchDepartment(dept: string): void {
    const index = this.batchSelectedDepartments.indexOf(dept);

    if (index === -1) {
      // 未選中，添加到已選
      this.batchSelectedDepartments.push(dept);
    } else {
      // 已選中，移除
      this.batchSelectedDepartments.splice(index, 1);
    }
  }

  // 從已選中移除部門（透過標籤的 X 按鈕）
  removeBatchDepartment(dept: string, event?: Event): void {
    if (event) {
      event.stopPropagation(); // 防止事件冒泡
    }

    const index = this.batchSelectedDepartments.indexOf(dept);
    if (index !== -1) {
      this.batchSelectedDepartments.splice(index, 1);
    }
  }

  // 添加批次部門
  addBatchDepartment(): void {
    if (this.newBatchDepartment && this.newBatchDepartment.trim() !== '') {
      // 確保不重複添加相同名稱的部門
      if (
        !this.batchSelectedDepartments.includes(this.newBatchDepartment.trim())
      ) {
        this.batchSelectedDepartments.push(this.newBatchDepartment.trim());
      }
      this.newBatchDepartment = ''; // 清空輸入
    }
  }

  // 修改批次設定部門的方法
  applyBatchDepartments(): void {
    // 獲取所有選中的法規
    const selectedLaws = this.filteredLaws.filter((law) => law.selected);

    selectedLaws.forEach((law) => {
      // 根據更新模式處理部門
      if (this.batchDeptUpdateMode === 'replace') {
        // 替換模式：直接設置為新的部門列表
        law.law_tags = [...this.batchSelectedDepartments];
      } else {
        // 追加模式：添加新部門但避免重複
        if (!law.law_tags) law.law_tags = [];
        if (!Array.isArray(law.law_tags)) law.law_tags = [law.law_tags];

        this.batchSelectedDepartments.forEach((dept) => {
          if (!law.law_tags.includes(dept)) {
            law.law_tags.push(dept);
          }
        });
      }

      // 標記為已修改
      this.markLawAsModified(law.id);
    });

    // 將批次選擇的部門添加到 topicTags 中
    this.batchSelectedDepartments.forEach((dept) => {
      if (!this.topicTags.includes(dept)) {
        this.topicTags.push(dept);
      }
    });
    this.topicTags.sort();

    // 關閉對話框
    this.closeBatchDepartmentDialog();
  }

  /**
   * 更新法規到新版本
   * @param law 法規對象
   */
  updateToNewVersion(law: any): void {
    // 阻止事件冒泡，避免觸發 openArticlePopup
    event?.stopPropagation();

    // 確認對話框
    if (confirm(`確定要更新 "${law.law_name}" 到最新版本嗎？`)) {
      console.log(`更新法規 ${law.law_name} 到最新版本`);
      // 這裡實現更新法規的邏輯
      // 例如：調用 API 進行版本更新，然後重新加載數據
    }
  }

  // 將已選法規更新為最新版本
  updateToLatestRegulations(): void {
    // 取得所有已選中的法規
    const selectedLaws = this.filteredLaws.filter((law) => law.selected);

    if (selectedLaws.length === 0) {
      alert('請至少選擇一筆法規進行更新');
      return;
    }

    // 顯示載入中訊息
    const loadingMessage = document.createElement('div');
    loadingMessage.className = 'loading-message';
    loadingMessage.textContent = '正在取得最新法規資訊...';
    document.body.appendChild(loadingMessage);

    // 建立批次請求的法規名稱陣列
    const lawNames = selectedLaws.map((law) => law.law_name);

    // 向後端發送請求，尋找法規資料庫中的最新版本
    this.http
      .post(`${this.apiUrl}/api/law_database/find_latest`, {
        lawNames: lawNames,
      })
      .subscribe({
        next: (response: any) => {
          // 移除載入中訊息
          document.body.removeChild(loadingMessage);

          if (!response.data || response.data.length === 0) {
            alert('未找到任何最新法規資訊');
            return;
          }

          // 用於追蹤已更新和未更新的法規數量
          let updatedCount = 0;
          let notFoundCount = 0;

          // 遍歷所有選中的法規，更新它們的資訊
          selectedLaws.forEach((law) => {
            // 在回應中尋找對應的最新法規
            const latestLaw = response.data.find(
              (item: LawDatabaseItem) => item.lawName === law.law_name
            );

            console.log('最新法規:', latestLaw);

            if (latestLaw) {
              // 更新法規資訊
              const originalModifiedDate = law.law_modified_date;

              // 更新法規屬性
              law.law_modified_date = latestLaw.date;
              law.source = latestLaw.Source || '法規資料庫';
              law.articleCount = latestLaw.laws
                ? latestLaw.laws.length
                : law.articleCount;

              // 如果有法條內容，也更新
              if (latestLaw.laws && latestLaw.laws.length > 0) {
                law.articles = latestLaw.laws;
              }

              // 標記為已修改，便於後續保存
              this.markLawAsModified(law.id);
              updatedCount++;

              // 檢查日期是否有變更，如果有則提示
              if (originalModifiedDate !== latestLaw.date) {
                law.hasNewVersion = true;
              }
            } else {
              notFoundCount++;
            }
          });

          // 顯示更新結果
          if (updatedCount > 0) {
            alert(
              `已成功更新 ${updatedCount} 筆法規資訊。${
                notFoundCount > 0
                  ? `有 ${notFoundCount} 筆法規未找到更新資訊。`
                  : ''
              }`
            );
          } else {
            alert('所有選取的法規均未找到更新資訊。');
          }
        },
        error: (err) => {
          document.body.removeChild(loadingMessage);
          console.error('Failed to update regulations:', err);
          alert('取得最新法規資訊失敗，請稍後再試');
        },
      });
  }

  saveNewRegulation(): void {}

  // 開啟欄位設定彈窗
  openColumnSettings(event: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.showColumnSettings = true;
  }

  // 關閉欄位設定彈窗
  closeColumnSettings(): void {
    this.showColumnSettings = false;
  }

  // 儲存欄位設定
  saveColumnSettings(): void {
    // 更新可見欄位列表
    this.updateVisibleColumns();

    // 保存設定到 localStorage 或其他持久化存儲
    this.saveColumnSettingsToStorage();

    // 關閉設定窗口
    this.closeColumnSettings();
  }

  // 新增方法
  private updateVisibleColumns() {
    // 根據 availableColumns 的順序和 visible 屬性更新 visibleColumns
    this.visibleColumns = this.availableColumns
      .filter((column) => column.visible)
      .map((column) => ({ ...column })); // 建立新的物件引用，確保更新

    // 如果需要保持原始列表不變，可以在此保存原始順序
    // this.originalColumnOrder = [...this.availableColumns.map(col => col.id)];
  }

  // 讀取儲存的欄位設定
  loadColumnSettings(): void {
    const savedSettings = localStorage.getItem('regulationColumnSettings');
    if (savedSettings) {
      try {
        const parsedSettings = JSON.parse(savedSettings);

        // 更新順序和可見性，但保留原始欄位物件的其他屬性
        this.availableColumns = this.availableColumns.map((originalCol) => {
          const savedCol = parsedSettings.find(
            (col: any) => col.id === originalCol.id
          );
          return savedCol
            ? { ...originalCol, visible: savedCol.visible }
            : originalCol;
        });

        // 調整欄位順序
        this.availableColumns.sort((a, b) => {
          const aIndex = parsedSettings.findIndex(
            (col: any) => col.id === a.id
          );
          const bIndex = parsedSettings.findIndex(
            (col: any) => col.id === b.id
          );
          return aIndex - bIndex;
        });
      } catch (error) {
        console.error('載入欄位設定時出錯:', error);
      }
    }
  }

  // 檢查欄位是否可見
  isColumnVisible(columnId: string): boolean {
    const column = this.availableColumns.find((col) => col.id === columnId);
    return column ? column.visible : false;
  }

  // 處理拖放事件
  drop(event: CdkDragDrop<string[]>): void {
    // 使用 moveItemInArray 調整順序
    moveItemInArray(
      this.availableColumns,
      event.previousIndex,
      event.currentIndex
    );

    // 重要：標記順序已變更，需要在保存時更新
    this.columnsOrderChanged = true;

    // 可選：立即應用排序變更到視圖（不等待用戶點擊確認按鈕）
    // this.updateVisibleColumns();
  }

  // 開啟批次設定法規代碼對話框
  batchSetCode(): void {
    this.showBatchCodeDialog = true;
    this.showBatchDropdown = false; // 關閉下拉選單

    // 初始化預設值
    this.batchCodePrefix = '';
    this.batchCodeStartNumber = 1;
    this.batchCodeDigits = 3;
  }

  // 關閉批次設定法規代碼對話框
  closeBatchCodeDialog(): void {
    this.showBatchCodeDialog = false;
  }

  // 取得已選擇的法規數量
  getSelectedLawsCount(): number {
    return this.filteredLaws.filter((law) => law.selected).length;
  }

  // 預覽第一個法規代碼
  previewFirstCode(): string {
    return this.formatCode(this.batchCodeStartNumber);
  }

  // 預覽最後一個法規代碼
  previewLastCode(): string {
    const selectedCount = this.getSelectedLawsCount();
    if (selectedCount === 0) return '';

    const lastNumber = this.batchCodeStartNumber + selectedCount - 1;
    return this.formatCode(lastNumber);
  }

  // 根據設定格式化法規代碼
  formatCode(num: number): string {
    // 確保位數有效
    const digits = Math.max(1, Math.min(6, this.batchCodeDigits || 1));

    // 格式化數字，補足前導零
    let formattedNum = num.toString();
    while (formattedNum.length < digits) {
      formattedNum = '0' + formattedNum;
    }

    // 添加前綴
    return (this.batchCodePrefix || '') + formattedNum;
  }

  // 套用批次法規代碼
  applyBatchCodes(): void {
    const selectedLaws = this.filteredLaws.filter((law) => law.selected);
    if (selectedLaws.length === 0) {
      this.closeBatchCodeDialog();
      return;
    }

    let currentNumber = this.batchCodeStartNumber;

    // 為每個選中的法規設定代碼
    for (const law of selectedLaws) {
      law.law_index = this.formatCode(currentNumber);
      this.markLawAsModified(law.id);
      currentNumber++;
    }

    // 顯示成功提示
    alert(`已成功為 ${selectedLaws.length} 個法規設定代碼`);
    this.closeBatchCodeDialog();
  }

  // 標記法規為已修改
  markLawAsModified(id: string): void {
    if (!this.modifiedLaws.has(id)) {
      this.modifiedLaws.add(id);
      this.hasModifications = true;
    }
  }

  // 檢查法規是否被修改過
  isLawModified(lawId: string): boolean {
    return this.modifiedLaws.has(lawId);
  }

  // 修改儲存修改的法規時使用 law_tags
  saveAllModifications(): void {
    const modifiedCount = this.modifiedLaws.size;

    if (modifiedCount === 0) {
      return;
    }

    if (confirm(`確定要保存 ${modifiedCount} 筆已修改的資料嗎？`)) {
      const savePromises: Promise<any>[] = [];

      const updatedLaws: any[] = [];

      this.filteredLaws.forEach((law) => {
        if (this.modifiedLaws.has(law.id)) {
          // 一次性保存該行所有欄位
          const updateData = this.createLawUpdateData(law);
          updatedLaws.push(updateData);
        }
      });

      this.http
        .post(`${this.apiUrl}/api/law_database/bulkUpdateLawItem`, updatedLaws)
        .subscribe({
          next: (response: any) => {
            // 移除處理中訊息（如果有的話）
            const loadingMessage = document.querySelector('.loading-message');
            if (loadingMessage) {
              document.body.removeChild(loadingMessage);
            }

            if (response && response.success) {
              // 顯示成功訊息，包含更新統計
              const modifiedCount = this.modifiedLaws.size;
              const updatedCount = response.results?.updated || 0;
              const notFoundCount = response.results?.notFound || 0;
              const failedCount = response.results?.failed || 0;

              let successMessage = `已成功儲存 ${updatedCount} 筆資料`;

              // 如有統計差異，顯示詳細資訊
              if (notFoundCount > 0 || failedCount > 0) {
                successMessage += `\n未找到: ${notFoundCount} 筆，失敗: ${failedCount} 筆`;
              }

              alert(successMessage);

              // 清除修改標記
              this.modifiedLaws.clear();
              this.hasModifications = false;

              // 更新原始資料快照，以便後續比較變化
              this.filteredLaws.forEach((law) => {
                this.originalLawsData.set(law.law_id, {
                  law_index: law.law_index,
                  relevance: law.relevance,
                  law_tags: this.ensureArray(law.law_tags),
                });
              });
            } else {
              // API 請求成功但操作失敗
              throw new Error(response.message || '更新失敗');
            }
          },
          error: (error) => {
            // 移除處理中訊息（如果有的話）
            const loadingMessage = document.querySelector('.loading-message');
            if (loadingMessage && document.body.contains(loadingMessage)) {
              document.body.removeChild(loadingMessage);
            }

            console.error('儲存法規資料時發生錯誤:', error);
            alert('儲存過程中發生錯誤，請重試');
          },
          complete: () => {
            console.log('批次儲存請求已完成');

            // 確保處理中訊息被移除（以防萬一）
            const loadingMessage = document.querySelector('.loading-message');
            if (loadingMessage && document.body.contains(loadingMessage)) {
              document.body.removeChild(loadingMessage);
            }
          },
        });
    }
  }

  /**
   * Creates an update data object for a law with the current company ID and topic.
   * @param law The law object to create update data for
   * @returns An object structured for API updates
   */
  createLawUpdateData(law: any): any {
    return {
      companyid: this.companyId,
      topic: this.selectedTopic,
      type: law.type,
      laws: {
        law_id: law.law_id,
        law_source: law.law_source || '',
        law_url: law.law_url || '',
        law_key: law.law_key || '',
        law_code: law.law_code || '',
        law_name: law.law_name || '',
        law_publish_date: law.law_publish_date || '',
        law_modified_date: law.law_modified_date || '',
        law_modifytype: law.law_modifytype || '',
        law_version: law.law_version || '',
        law_category: law.law_category || '',
        law_hierarchy: law.law_hierarchy || '',
        law_change_history: law.law_change_history || '',
        law_remarks: law.law_remarks || '',
        law_tags: this.ensureArray(law.law_tags), // 使用輔助方法確保 law_tags 是陣列
        law_index: law.law_index, // 法規代碼
        law_articles: law.law_articles || [], // 法條內容
        results: law.results || {
          related: law.relevance === 'related' ? 'V' : null,
          unrelated: law.relevance === 'unrelated' ? 'V' : null,
          reference: law.relevance === 'reference' ? 'V' : null,
        },
        updatedDate: new Date().toISOString().split('T')[0],
        updatedBy: '',
      },
    };
  }

  // 修改取消所有修改的方法
  cancelAllModifications(): void {
    const modifiedCount = this.modifiedLaws.size;

    if (modifiedCount === 0) {
      return;
    }

    if (confirm(`確定要取消 ${modifiedCount} 筆尚未儲存的修改嗎？`)) {
      // 恢復原始數據
      this.filteredLaws.forEach((law) => {
        if (this.modifiedLaws.has(law.law_id)) {
          const originalData = this.originalLawsData.get(law.law_id);
          if (originalData) {
            law.law_index = originalData.law_index;
            law.relevance = originalData.relevance;
            law.law_tags = originalData.law_tags
              ? [...originalData.law_tags]
              : [];
            law.law_url = originalData.law_url;
            law.law_hierarchy = originalData.law_hierarchy; // 恢復原始層級
          }
        }
      });

      this.modifiedLaws.clear();
      this.hasModifications = false;
      alert('已取消所有尚未儲存的修改');
    }
  }

  addNewRegulationBySample(): void {
    // Hide the dropdown menu
    this.showAddDropdown = false;

    // Show loading state
    const loadingMessage = document.createElement('div');
    loadingMessage.className = 'loading-message';
    loadingMessage.textContent = '載入法規範例資料中...';
    document.body.appendChild(loadingMessage);

    // First, fetch all available topics from the sample API
    this.http
      .get(`${this.apiUrl}/api/regulation/law_sample/topics?companyid=quallico`)
      .subscribe({
        next: (response: any) => {
          // Remove loading message
          document.body.removeChild(loadingMessage);

          // Save topics to component property
          this.sampleTopics = response.data || [];

          // Show the sample selection dialog
          this.showSampleSelectionDialog = true;

          // Reset selection state
          this.selectedSampleTopic =
            this.sampleTopics.length > 0 ? this.sampleTopics[0] : '';
          this.sampleLaws = [];
          this.selectedSampleLaws = new Set();

          // If we have topics, load the first one's samples
          if (this.selectedSampleTopic) {
            this.loadSampleLaws(this.selectedSampleTopic);
          }
        },
        error: (err) => {
          document.body.removeChild(loadingMessage);
          console.error('Failed to load sample topics:', err);
          alert('載入法規範例資料失敗，請稍後再試');
        },
      });
  }

  // Load sample laws for a specific topic
  loadSampleLaws(topic: string): void {
    // Update the selected topic
    this.selectedSampleTopic = topic;

    // Show loading state
    this.isSampleLoading = true;

    // Reset the selection
    this.selectedSampleLaws.clear();

    // Fetch samples for the selected topic
    this.http
      .get(
        `${
          this.apiUrl
        }/api/regulation/law_sample/getsample?companyid=quallico&topic=${encodeURIComponent(
          topic
        )}`
      )
      .subscribe({
        next: (response: any) => {
          console.log('Sample laws loaded:', response);

          this.sampleLaws = response.data || [];
          this.filteredSampleLaws = [...this.sampleLaws]; // 初始化篩選列表

          // 只有在有搜尋關鍵字且之前有進行過搜尋時，才重新應用搜尋
          // 這樣可以避免在載入資料時不當觸發搜尋
          if (this.sampleSearchKeyword && this.sampleSearchKeyword.trim() && this.isSearchTriggeredByUser) {
            console.log('重新應用之前的搜尋條件:', this.sampleSearchKeyword);
            this.searchSampleLaws();
          }

          this.isSampleLoading = false;
        },
        error: (err) => {
          console.error('Failed to load sample laws:', err);
          alert('載入法規範例資料失敗，請稍後再試');
          this.isSampleLoading = false;
          this.sampleLaws = [];
        },
      });
  }

  // Toggle selection of a sample law
  toggleSampleLawSelection(lawId: string): void {
    if (this.selectedSampleLaws.has(lawId)) {
      this.selectedSampleLaws.delete(lawId);
    } else {
      this.selectedSampleLaws.add(lawId);
    }
  }

  // Check if a sample law is selected
  isSampleLawSelected(lawId: string): boolean {
    return this.selectedSampleLaws.has(lawId);
  }

  // Close the sample selection dialog
  closeSampleSelectionDialog(): void {
    this.showSampleSelectionDialog = false;
    this.sampleSearchKeyword = ''; // 重置搜尋關鍵字
    this.isSearchTriggeredByUser = false; // 重置搜尋觸發標識
    this.filteredSampleLaws = [...this.sampleLaws]; // 重置篩選列表
  }

  // 搜尋範例法規
  searchSampleLaws(): void {
    console.log('搜尋被觸發，關鍵字:', this.sampleSearchKeyword);

    if (!this.sampleSearchKeyword.trim()) {
      // 如果搜尋關鍵字為空，顯示所有法規
      this.filteredSampleLaws = [...this.sampleLaws];
    } else {
      // 根據法規名稱進行篩選
      const keyword = this.sampleSearchKeyword.toLowerCase().trim();

      this.filteredSampleLaws = this.sampleLaws.filter(law => {
        // 檢查法規名稱
        const lawNameMatch = law.law_name && law.law_name.toLowerCase().includes(keyword);
        // 檢查分類
        const typeMatch = law.type && law.type.toLowerCase().includes(keyword);
        // 檢查位階
        const hierarchyMatch = law.law_hierarchy && law.law_hierarchy.toLowerCase().includes(keyword);

        return lawNameMatch || typeMatch || hierarchyMatch;
      });
    }

    console.log('搜尋結果數量:', this.filteredSampleLaws.length);
  }

  // 處理搜尋按鈕點擊事件
  onSearchButtonClick(): void {
    console.log('用戶點擊搜尋按鈕');
    this.isSearchTriggeredByUser = true;
    this.searchSampleLaws();
  }

  // 清除搜尋
  clearSampleSearch(): void {
    console.log('清除搜尋');
    this.sampleSearchKeyword = '';
    this.isSearchTriggeredByUser = false;
    this.filteredSampleLaws = [...this.sampleLaws];
  }

  // Add selected sample laws to regulation list
  addSelectedSampleLaws(): void {
    this.isAddingSampleLaws = true;

    if (
      this.selectedSampleLaws.size === 0 ||
      !this.isValidSampleSelectionForm()
    ) {
      this.isAddingSampleLaws = false;
      return;
    }

    // 獲取實際的公司ID和主題
    const companyId = this.isNewCompany
      ? this.newCompanyName.trim()
      : this.selectedCompanyForSample;
    const topic = this.isNewTopic
      ? this.newTopicName.trim()
      : this.selectedTopicForSample;

    // 決定要使用的類型
    let targetType = '';
    if (this.typeSelectionMode === 'existing') {
      targetType = this.selectedTargetType;
    } else if (this.typeSelectionMode === 'new') {
      targetType = this.newTypeName.trim();
    } else if (
      this.typeSelectionMode === 'original' &&
      this.sampleLaws.length > 0
    ) {
      // 使用第一個選中的法規的類型作為預設值
      const firstSelectedId = Array.from(this.selectedSampleLaws)[0];
      const firstSelectedLaw = this.sampleLaws.find(
        (law) => (law.law_id || law.id) === firstSelectedId
      );
      if (firstSelectedLaw) {
        targetType = firstSelectedLaw.type || '';
      }
    }

    // 取得當前日期字串 (YYYY-MM-DD)
    const today = new Date().toISOString().split('T')[0];

    // 準備批次請求資料
    const requests: any[] = [];

    // 遍歷所有選擇的法規
    this.sampleLaws.forEach((law) => {
      const lawId = law.law_id || law.id;

      if (this.selectedSampleLaws.has(lawId)) {
        // 建立符合所需結構的法規物件
        const lawRequest = {
          companyid: companyId,
          topic: topic,
          type: law.type,
          laws: {
            law_id: law.law_name, // 使用法規名稱作為 ID
            law_source: this.getlawsourcename(law.law_url),
            law_url: law.law_url || '',
            law_key: law.law_key || '',
            law_code: law.law_code || '',
            law_name: law.law_name || '',
            law_publish_date: law.law_publish_date || '',
            law_modified_date: law.law_modified_date || '',
            law_modifytype: law.law_modifytype || '',
            law_version: law.law_version || '',
            law_category: law.law_category || '',
            law_hierarchy: law.law_hierarchy || '',
            law_change_history: law.lae_change_history || '',
            law_remarks: law.law_remarks || '',
            law_tags: law.law_tags || '',
            results: {
              related: null,
              unrelated: null,
              reference: null,
            },
            addedToListDate: today,
            updatedBy: '',
            updatedDate: today,
          },
        };

        requests.push(lawRequest);
      }
    });

    this.http
      .post(`${this.apiUrl}/api/law_database/bulkAddLaws`, requests)
      .subscribe({
        next: (response: any) => {
          // 移除載入提示

          if (response.success) {
            // 顯示成功訊息，包括添加和已存在的數量
            const addedCount = response.results?.added || 0;
            const alreadyExistsCount = response.results?.alreadyExists || 0;

            let successMessage = `已成功添加 ${addedCount} 筆法規資料`;
            if (alreadyExistsCount > 0) {
              successMessage += `，${alreadyExistsCount} 筆已存在的法規被跳過`;
            }

            alert(successMessage);

            // 關閉對話框
            this.closeSampleSelectionDialog();

            // 重新載入法規列表以顯示新添加的法規
            if (
              this.selectedCompany === companyId &&
              this.selectedTopic === topic
            ) {
              this.loadRegulations();
            } else {
              // 如果選擇的是不同公司或主題，提示用戶
              alert(
                `法規已添加到 ${companyId} 公司的 ${topic} 主題下，您可以切換到相應主題查看。`
              );
            }

            this.isAddingSampleLaws = false;
          } else {
            // 顯示錯誤訊息
            const errorMsg =
              response.errors && response.errors.length > 0
                ? response.errors.join('\n')
                : response.message || '未知錯誤';

            alert(`添加法規失敗: ${errorMsg}`);
            this.isAddingSampleLaws = false;
          }
        },
        error: (error) => {
          // 移除載入提示

          // 顯示錯誤訊息
          console.error('添加範例法規失敗:', error);
          alert(`添加法規失敗: ${error.message || '網路錯誤，請稍後再試'}`);
          this.isAddingSampleLaws = false;
        },
      });
  }

  /**
   * Toggles selection state for all sample laws (只針對目前篩選後的法規)
   */
  toggleAllSampleLaws(event: Event): void {



    const checkbox = event.target as HTMLInputElement;

    if (checkbox.checked) {
      // Select all filtered laws
      this.filteredSampleLaws.forEach((law) => {
        const id = law.law_id || law.id;
        if (id) {
          this.selectedSampleLaws.add(id);
        }
      });
    } else {
      // Clear selections for filtered laws only
      this.filteredSampleLaws.forEach((law) => {
        const id = law.law_id || law.id;
        if (id) {
          this.selectedSampleLaws.delete(id);
        }
      });
    }
  }

  // 当公司下拉选择改变时
  onSampleCompanyChange() {
    if (this.selectedCompanyForSample === '__new__') {
      this.isNewCompany = true;
      this.newCompanyName = '';
      // 如果选择了新公司，需要调整类型选择模式
      if (this.typeSelectionMode === 'existing') {
        this.typeSelectionMode = 'original';
      }
    }
  }

  // 当主题下拉选择改变时
  onSampleTopicChange() {
    if (this.selectedTopicForSample === '__new__') {
      this.isNewTopic = true;
      this.newTopicName = '';
      // 如果选择了新主题，需要调整类型选择模式
      if (this.typeSelectionMode === 'existing') {
        this.typeSelectionMode = 'original';
      }
    }
  }

  // 取消新公司输入
  cancelNewCompany() {
    this.isNewCompany = false;
    this.selectedCompanyForSample = this.selectedCompany || '';
  }

  // 取消新主题输入
  cancelNewTopic() {
    this.isNewTopic = false;
    this.selectedTopicForSample = this.selectedTopic || '';
  }

  // 验证表单是否有效
  isValidSampleSelectionForm(): boolean {
    // 检查公司和主题是否有效
    const companyValid = this.isNewCompany
      ? !!this.newCompanyName.trim()
      : !!this.selectedCompanyForSample &&
        this.selectedCompanyForSample !== '__new__';

    const topicValid = this.isNewTopic
      ? !!this.newTopicName.trim()
      : !!this.selectedTopicForSample &&
        this.selectedTopicForSample !== '__new__';

    // 检查类型选择是否有效
    let typeValid = false;
    if (this.typeSelectionMode === 'original') {
      typeValid = true;
    } else if (
      this.typeSelectionMode === 'existing' &&
      !this.isNewCompany &&
      !this.isNewTopic
    ) {
      typeValid = !!this.selectedTargetType;
    } else if (this.typeSelectionMode === 'new') {
      typeValid = !!this.newTypeName.trim();
    }

    return companyValid && topicValid && typeValid;
  }

  // 獲取法規內容
  fetchLawContent(law: any): void {
    // 設置為載入中狀態
    law.isLoading = true;
    law.loadFailed = false;

    // 使用 URLSearchParams 構建查詢參數
    const params = new HttpParams().set('lawurl', law.law_url || '');

    // 發送 GET 請求到後端 API 獲取法條內容
    this.http
      .get<any>(`${this.apiUrl}/api/lawParser/fetchLaw`, { params })
      .subscribe({
        next: (response) => {
          // 請求完成，取消載入狀態
          law.isLoading = false;

          if (response && response.laws) {
            //如果法規名稱是空白的，但API有取得資料，就更新法規名稱
            if (!law.law_name && response.laws.law_name) {
              law.law_name = response.laws.law_name;
            }

            // 計算正式法條(A 類型)的數量
            const typeAArticles = response.laws.law_articles.filter(
              (article: { article_type: string }) =>
                article.article_type === 'A'
            );

            // 更新法規資訊
            law.law_publish_date = response.laws.law_publish_date;
            law.law_modified_date = response.laws.law_modified_date;

            //更新法條資訊
            law.law_articles = response.laws.law_articles;
            law.articleCount = typeAArticles.length;

            // 確保狀態重置
            law.loadFailed = false;

            // console.log("law",law);

            //直接將法條內容，寫回資料庫中
            var convertedLaw = this.convertlawstructure(law);

            //  console.log("convertedLaw",convertedLaw);

            //有抓到法條，才更新進去? 還是都更新呢?
            if (convertedLaw.laws.law_articles.length > 0) {
              // 調用 API 將法規內容更新至資料庫
              this.updateLawItemToDatabase(convertedLaw);
            } else {
              law.loadFailed = true;
            }

            // 添加到修改列表以便保存
            // this.markLawAsModified(law.id);

            // 更新需要載入的法規數量
            this.calculateLawsNeedingContent();
          } else {
            // 資料無效
            law.loadFailed = true;
          }
        },
        error: (err) => {
          // 請求失敗，設置錯誤狀態
          law.isLoading = false;
          law.loadFailed = true;
          console.error('取得法條內容失敗:', err);

          // 更新需要載入的法規數量
          this.calculateLawsNeedingContent();
        },
      });
  }

  // fetchRegulationContent(): void {
  //   if (!this.newRegulation.law_url) {
  //     alert('請先輸入法規網址');
  //     return;
  //   }

  //   try {

  //      const params = new HttpParams()
  //     .set('lawurl', this.newRegulation.law_url);

  //   // 發送 GET 請求到後端 API 獲取法條內容
  //   this.http
  //     .get<any>(`${this.apiUrl}/api/lawParser/fetchLaw`, { params })
  //     .subscribe({
  //       next: (response) => {

  //         console.log('法規爬取成功:', response);

  //         this.updateRegulationForm(response);
  //       },
  //       error: (error) => {
  //         console.error('法規爬取失敗:', error);
  //         alert('法規爬取失敗: ' + (error.message || '未知錯誤'));
  //       },
  //     });
  //   } catch (error) {
  //     console.error('處理法規 URL 時出錯:', error);
  //     alert('無法識別的法規網址格式，請確認網址正確性');
  //   }
  // }

  convertlawstructure_scan_history(law:any,type:string): any {

    console.log("law", law);

    if (!law) return null;

    // 提取法規主題 (可能需要根據實際情況調整)
    const topic = this.selectedTopic;
    // 提取或保留原始類型

     // 創建輸出結構
    const convertedLaw = {
      companyid: this.companyId,
      topic: topic,
      type: type,
      parserdate: new Date().toISOString().split('T')[0],
      law
      }

    return convertedLaw;

  }

  convertlawstructure(law: any): any {
    if (!law) return null;

    // 提取法規主題 (可能需要根據實際情況調整)
    const topic = this.selectedTopic;

    // 提取或保留原始類型
    const type = law.type;

    // 創建輸出結構
    const convertedLaw = {
      companyid: this.companyId,
      topic: topic,
      type: type,
      laws: {
        // 將原始法規資訊直接複製到 laws 對象中
        law_id: law.law_id,
        law_source: law.law_source || '',
        law_url: law.law_url || '',
        law_key: law.law_key || '',
        law_code: law.law_code || '',
        law_name: law.law_name || '',
        law_publish_date: law.law_publish_date || '',
        law_modified_date: law.law_modified_date || '',
        law_modifytype: law.law_modifytype || '',
        law_version: law.law_version || '',
        law_category: law.law_category || '',
        law_hierarchy: law.law_hierarchy || '',
        law_change_history:
        law.law_change_history ||'',
        law_remarks: law.law_remarks || '',
        law_tags: law.law_tags || '',
        results: law.results || {
          related: null,
          unrelated: null,
          reference: null,
        },
        addedToListDate:
          law.addedToListDate || new Date().toISOString().split('T')[0],
        updatedBy: law.updatedBy || '',
        updatedDate: law.updatedDate || new Date().toISOString().split('T')[0],
        // 複製法條內容
        law_articles: law.law_articles || [],
      },
    };

    // 生成唯一ID (如果需要)
    // convertedLaw.id = law.id || this.generateUuid();

    return convertedLaw;
  }

  // 更新法規內容到資料庫
  updateLawItemToDatabase(law: any): void {
    // 發送 POST 請求到更新 API
    this.http
      .post(`${this.apiUrl}/api/law_database/updateLawItem`, law)
      .subscribe({
        next: (response: any) => {
          // 移除處理中提示

          if (response && response.success) {
            // 顯示成功訊息

            // 標記為已修改並已保存
            // this.markLawAsModified(law.id);

            // 更新法規數據快照
            this.originalLawsData.set(law.law_id, {
              law_index: law.law_index,
              relevance: law.relevance,
              law_tags: this.ensureArray(law.law_tags),
              articleCount: law.articleCount,
              law_articles: law.law_articles ? [...law.law_articles] : [],
            });
          } else {
            // 顯示錯誤訊息
            alert('更新法規內容失敗: ' + (response.message || '未知錯誤'));
          }
        },
        error: (error) => {
          // 顯示錯誤訊息
          console.error('更新法規內容到資料庫失敗:', error);
          alert(
            '更新法規內容失敗: ' + (error.message || '網路錯誤，請稍後再試')
          );
        },
      });
  }

  // 快速新增法規行
  addInlineRegulation(): void {
    // 關閉下拉選單
    this.showAddDropdown = false;

    // 初始化新法規物件
    this.newInlineLaw = {
      type: this.selectedType !== 'ALL' ? this.selectedType : '',
      law_name: '',
      law_url: '',
      law_hierarchy: '命令',
      law_index: '',
      law_modified_date: new Date().toISOString().substring(0, 10),
      relevance: '參考',
      law_tags: [], // 使用 law_tags 替代 departments
      articleCount: 0,
      isLoading: false,
      loadFailed: false,
    };

    // 啟用內聯編輯模式
    this.inlineEditing = true;

    // 使用 setTimeout 確保 DOM 更新後再聚焦
    setTimeout(() => {
      // 聚焦到法規名稱輸入框
      const nameInput = document.querySelector(
        '.editing-row input[placeholder="請輸入法規名稱"]'
      ) as HTMLInputElement;
      if (nameInput) {
        nameInput.focus();
      }
    }, 100);
  }

  // 儲存內聯編輯的法規
  saveInlineLaw(): void {
    // 驗證必填欄位
    if (!this.newInlineLaw.law_name || !this.newInlineLaw.type) {
      alert('請輸入分類與法規名稱');
      return;
    }

    // 生成暫時的唯一ID
    const tempId = `temp_${Date.now()}`;

    // 準備 API 所需的資料結構
    const lawData = {
      companyid: this.companyId,
      topic: this.selectedTopic,
      type: this.newInlineLaw.type,
      laws: {
        law_id: tempId,
        law_name: this.newInlineLaw.law_name,
        law_url: this.newInlineLaw.law_url || '',
        law_hierarchy: this.newInlineLaw.law_hierarchy,
        law_modified_date: this.newInlineLaw.law_modified_date,
        law_index: this.newInlineLaw.law_index || '',
        relevance: this.newInlineLaw.relevance,
        law_tags: [...(this.newInlineLaw.law_tags || [])],
        articleCount: this.newInlineLaw.articleCount || 0,
        law_articles:
          this.newInlineLaw.articles && this.newInlineLaw.articles.length > 0
            ? [...this.newInlineLaw.articles]
            : [],
        // 其他欄位可依需求補充
      },
    };

    // 呼叫 API 儲存
    this.http
      .post(`${this.apiUrl}/api/law_database/bulkInsertLawItem`, [lawData])
      .subscribe({
        next: (response: any) => {
          if (response && response.success) {
            // 取得回傳的資料（假設回傳陣列）
            const insertedLaw =
              response.data && response.data[0]
                ? response.data[0]
                : {
                    ...lawData.laws,
                    type: lawData.type,
                    id: tempId,
                    selected: false,
                    isNew: false,
                  };

            // 加入到 filteredLaws 最前面
            this.filteredLaws.unshift(insertedLaw);

            // 關閉編輯模式
            this.inlineEditing = false;
            this.showInlineDeptInput = false;

            // 記錄此筆資料為已修改(新增)的資料
            // this.markLawAsModified(insertedLaw.id || tempId);

            // 保存原始數據快照
            this.originalLawsData.set(insertedLaw.law_id || tempId, {
              law_index: insertedLaw.law_index,
              relevance: insertedLaw.relevance,
              law_tags: insertedLaw.law_tags ? [...insertedLaw.law_tags] : [],
            });

            // 如果有新增的類型，更新uniqueTypesWithCounts
            if (
              !this.uniqueTypesWithCounts.some(
                (item) => item.type === insertedLaw.type
              )
            ) {
              this.uniqueTypesWithCounts.push({
                type: insertedLaw.type,
                count: 1,
              });
            } else {
              // 更新現有類型的計數
              const typeItem = this.uniqueTypesWithCounts.find(
                (item) => item.type === insertedLaw.type
              );
              if (typeItem) {
                typeItem.count++;
              }
            }

            alert('法規已成功儲存並加入清單。');
          } else {
            alert('儲存失敗: ' + (response?.message || '未知錯誤'));
          }
        },
        error: (err) => {
          alert(
            '儲存失敗: ' + (err?.error?.message || err.message || '網路錯誤')
          );
        },
      });
  }

  // 取消內聯編輯
  cancelInlineEdit(): void {
    this.inlineEditing = false;
    this.showInlineDeptInput = false;
  }

  // 為新增的法規獲取法條內容
  fetchInlineLawContent(): void {
    // 檢查是否有URL
    if (!this.newInlineLaw.law_url) {
      alert('請先輸入法規網址');
      return;
    }

    // 設置為載入中狀態
    this.newInlineLaw.isLoading = true;
    this.newInlineLaw.loadFailed = false;

    // 準備請求參數
    const params = new HttpParams().set('lawurl', this.newInlineLaw.law_url);

    // 發送 GET 請求到後端 API 獲取法條內容
    this.http
      .get<any>(`${this.apiUrl}/api/lawParser/fetchLaw`, { params })
      .subscribe({
        next: (response) => {
          // 請求完成，取消載入狀態
          this.newInlineLaw.isLoading = false;

          if (response && response.laws) {
            //如果法規名稱是空白的，但API有取得資料，就更新法規名稱
            if (!this.newInlineLaw.law_name && response.laws.law_name) {
              this.newInlineLaw.law_name = response.laws.law_name;
            }
            // 如果 API 回傳的 law_url 跟目前的不一樣，則更新
            if (
              response.laws.law_url &&
              response.laws.law_url !== this.newInlineLaw.law_url
            ) {
              this.newInlineLaw.law_url = response.laws.law_url;
            }

            // 計算正式法條(A 類型)的數量
            const typeAArticles = response.laws.law_articles.filter(
              (article: { article_type: string }) =>
                article.article_type === 'A'
            );

            // 更新法規資訊
            this.newInlineLaw.articles = response.laws.law_articles;
            this.newInlineLaw.articleCount = typeAArticles.length;

            // 如果有修訂日期，也一併更新
            if (response.laws.law_modified_date) {
              this.newInlineLaw.law_modified_date =
                response.laws.law_modified_date;
            }

            alert(
              `成功取得《${this.newInlineLaw.law_name}》的法條內容，共 ${typeAArticles.length} 條。`
            );
          } else {
            this.newInlineLaw.loadFailed = true;
            alert('無法解析法規內容，請稍後再試。');
          }
        },
        error: (err) => {
          this.newInlineLaw.isLoading = false;
          this.newInlineLaw.loadFailed = true;
          console.error('取得法條內容失敗:', err);
          alert('取得法條內容失敗，請稍後再試。');
        },
      });
  }

  // 顯示部門輸入框
  showInlineDeptInputarea(): void {
    this.showInlineDeptInput = true;
    this.inlineDeptInput = '';

    setTimeout(() => {
      const deptInput = document.querySelector(
        '.editing-row .department-input'
      ) as HTMLInputElement;
      if (deptInput) {
        deptInput.focus();
      }
    }, 100);
  }

  // 處理部門輸入變化
  onInlineDeptInputChange(event: Event): void {
    const value = (event.target as HTMLInputElement).value;

    // 篩選建議部門
    if (value) {
      this.inlineDeptSuggestions = this.availableEmails.filter((dept) =>
        dept.toLowerCase().includes(value.toLowerCase())
      );
    } else {
      this.inlineDeptSuggestions = [];
    }
  }

  // 處理部門輸入框按鍵
  handleInlineDeptKeyDown(event: KeyboardEvent): void {
    // 處理特殊按鍵，如Esc取消輸入
    if (event.key === 'Escape') {
      this.showInlineDeptInput = false;
    }
  }

  // 修改內聯法規添加部門的方法
  addInlineDepartment(): void {
    if (this.inlineDeptInput && this.inlineDeptInput.trim() !== '') {
      // 初始化 law_tags 為陣列（如果不存在）
      if (!this.newInlineLaw.law_tags) {
        this.newInlineLaw.law_tags = [];
      }

      // 添加新部門
      this.newInlineLaw.law_tags.push(this.inlineDeptInput.trim());

      // 清空輸入
      this.inlineDeptInput = '';

      // 不關閉輸入框，允許連續添加
    }
  }

  // 修改移除內聯法規部門的方法
  removeInlineDepartment(index: number): void {
    if (
      this.newInlineLaw.law_tags &&
      index >= 0 &&
      index < this.newInlineLaw.law_tags.length
    ) {
      this.newInlineLaw.law_tags.splice(index, 1);
    }
  }

  // Excel匯入對話框相關方法
  openExcelImportDialog() {
    this.showExcelImportDialog = true;
    this.showAddDropdown = false;
    this.resetExcelImport();

    // 使用當前選擇的公司和主題作為預設值
    this.importCompanyId = this.selectedCompany || this.companyId || '';
    this.importTopic = this.selectedTopic || '';
  }

  closeExcelImportDialog() {
    if (!this.isImporting) {
      this.showExcelImportDialog = false;
      this.resetExcelImport();
    }
  }

  resetExcelImport() {
    this.excelFile = null;
    this.excelDataPreview = [];
    this.dataValidationResults = [];
    this.importProgress = 0;
    this.importStatus = '';
    this.isImporting = false;
    this.hasValidationErrors = false;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    // 可以添加拖拉時的視覺效果
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onFileDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
      const file = event.dataTransfer.files[0];
      if (this.isValidExcelFile(file)) {
        this.excelFile = file;
      } else {
        this.showErrorMessage('請上傳有效的Excel檔案(.xlsx)');
      }
    }
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      if (this.isValidExcelFile(file)) {
        this.excelFile = file;
      } else {
        this.showErrorMessage('請上傳有效的Excel檔案(.xlsx)');
      }
    }
  }

  isValidExcelFile(file: File): boolean {
    const validExts = ['.xlsx'];
    const fileName = file.name;
    const fileExt = fileName.substring(fileName.lastIndexOf('.'));
    return validExts.includes(fileExt.toLowerCase());
  }

  removeSelectedFile() {
    this.excelFile = null;
    this.excelDataPreview = [];
    this.dataValidationResults = [];
  }

  // 匯入Excel資料 - 修改後的版本
  importExcelData() {
    // 檢查是否有選擇檔案並填寫公司ID和主題
    if (
      !this.excelFile ||
      !this.importCompanyId ||
      !this.importTopic ||
      this.hasValidationErrors
    ) {
      if (!this.excelFile) {
        this.showErrorMessage('請選擇Excel檔案');
      } else if (!this.importCompanyId) {
        this.showErrorMessage('請輸入公司代碼');
      } else if (!this.importTopic) {
        this.showErrorMessage('請輸入主題');
      }
      return;
    }

    this.isImporting = true;
    this.importProgress = 0;
    this.importStatus = '開始轉換資料...';

    // 使用FormData來處理檔案上傳
    const formData = new FormData();
    formData.append('file', this.excelFile);
    formData.append('companyid', this.importCompanyId);
    formData.append('topic', this.importTopic);

    // 發送POST請求到匯入API
    this.http
      .post(`${this.apiUrl}/api/importTools/regulationlist`, formData)
      .subscribe({
        next: (response: any) => {
          // 處理回應
          if (response.success) {
            console.log('解析結果:', response);
            this.excelconveterresult = response.data;
            this.importStatus = `成功取得 ${response.data.length} 筆資料`;
            this.importProgress = 100;
            this.isImporting = false;
          } else {
            this.importStatus = '解析失敗';
            this.showErrorMessage(`解析失敗: ${response.error || '未知錯誤'}`);
            this.isImporting = false;
          }
        },
        error: (error) => {
          this.importStatus = '解析失敗';
          this.showErrorMessage(
            `解析資料時發生錯誤: ${error.message || '伺服器錯誤'}`
          );
          this.isImporting = false;
        },
        complete: () => {
          // 匯入操作完成
        },
      });
  }

  downloadResultsAsJson(): void {
    if (!this.excelconveterresult || this.excelconveterresult.length === 0) {
      this.showErrorMessage('沒有可下載的資料');
      return;
    }

    try {
      // Convert data to a JSON string with proper formatting
      const jsonString = JSON.stringify(this.excelconveterresult, null, 2);

      // Create a blob with the JSON data
      const blob = new Blob([jsonString], { type: 'application/json' });

      // Create a URL for the blob
      const url = window.URL.createObjectURL(blob);

      // Create a link element and simulate a click to download the file
      const downloadLink = document.createElement('a');
      downloadLink.href = url;

      // Generate filename with timestamp
      const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
      downloadLink.download = `regulation-import-${timestamp}.json`;

      // Append to the document, click and remove
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);

      // Clean up the URL object
      window.URL.revokeObjectURL(url);

      this.showSuccessMessage('已成功下載 JSON 檔案');
    } catch (error) {
      console.error('下載 JSON 檔案時發生錯誤:', error);
      this.showErrorMessage('下載 JSON 檔案失敗');
    }
  }

  // 顯示錯誤訊息
  showErrorMessage(message: string) {
    // 實際實現中使用您的通知服務
    console.error(message);
    // this.notificationService.showError(message);
  }

  // 顯示成功訊息
  showSuccessMessage(message: string) {
    // 實際實現中使用您的通知服務
    console.log(message);
    // this.notificationService.showSuccess(message);
  }

  getlawsourcename(lawurl: string): string {
    // 如果沒有URL，返回空字符串
    if (!lawurl) return '';

    try {
      // 解析URL獲取hostname
      const url = new URL(lawurl);
      const hostname = url.hostname;

      // 定義主要法規網站的映射表
      const hostMappings: Record<string, string> = {
        'law.moj.gov.tw': '全國法規資料庫',
        'laws.mol.gov.tw': '勞動部',
        'law.epa.gov.tw': '環境保護署',
        'laws.moj.gov.tw': '法務部',
        'mojlaw.moj.gov.tw': '法務部',
        'gazette.nat.gov.tw': '國家發展委員會',
        'www.osha.gov.tw': '職業安全衛生署',
        'law.coa.gov.tw': '農業委員會',
        'law.banking.gov.tw': '金融監督管理委員會',
        'laws.fsc.gov.tw': '金融監督管理委員會',
        'law.cdc.gov.tw': '疾病管制署',
        'law.nfa.gov.tw': '消防署',
        'law.dot.gov.tw': '交通部',
        'oaout.moenv.gov.tw': '環境部',
        'lawsearch.pcc.gov.tw': '公共工程委員會',
        'law.moea.gov.tw': '經濟部',
      };

      // 檢查映射表中是否有對應的主機名稱
      if (hostname in hostMappings) {
        return hostMappings[hostname];
      }

      // 如果沒有映射則返回主機名稱
      return hostname;
    } catch (error) {
      console.error('解析URL時發生錯誤:', error);
      // 如果URL格式無效，直接返回原始URL
      return lawurl;
    }
  }

  public isSampleSelectionExpanded: boolean = true;
  // Add this method to your component class
  toggleSampleSelectionVisibility(): void {
    this.isSampleSelectionExpanded = !this.isSampleSelectionExpanded;
  }

  // 添加確保陣列的輔助方法
  ensureArray(value: any): any[] {
    if (Array.isArray(value)) {
      return value;
    } else if (value) {
      // 如果是字串或其他非空值，將其包裝為陣列
      return [value];
    } else {
      // 如果是 null 或 undefined，返回空陣列
      return [];
    }
  }

  // 開始編輯法規來源
  editSource(law: any): void {
    // 先關閉其他所有編輯狀態
    this.filteredLaws.forEach((l) => {
      if (l !== law) {
        l.isEditingSource = false;
      }
    });

    // 設置當前法規為編輯模式
    law.isEditingSource = true;

    // 使用setTimeout確保DOM已更新，然後聚焦輸入框
    setTimeout(() => {
      document.getElementById(`sourceInput-${law.law_id}`)?.focus();
    }, 0);
  }

  // 儲存法規來源
  saveSource(law: any): void {
    // 如果URL有變更，標記為已修改
    if (this.originalLawsData.has(law.law_id)) {
      const originalData = this.originalLawsData.get(law.law_id);
      if (originalData && originalData.law_url !== law.law_url) {
        this.markLawAsModified(law.id);
      }
    } else {
      // 若沒有原始資料參照，直接標記為已修改
      this.markLawAsModified(law.id);
    }

    // 退出編輯模式
    law.isEditingSource = false;
  }

  // 開始編輯法規層級
  editHierarchy(law: any): void {
    // 先關閉其他所有編輯狀態
    this.filteredLaws.forEach((l) => {
      if (l !== law) {
        l.isEditingHierarchy = false;
      }
    });

    // 設置當前法規為層級編輯模式
    law.isEditingHierarchy = true;

    // 使用 setTimeout 確保 DOM 已更新，然後聚焦輸入框
    setTimeout(() => {
      document.getElementById(`hierarchyInput-${law.law_id}`)?.focus();
    }, 0);
  }

  // 儲存法規層級
  saveHierarchy(law: any): void {
    // 判斷是否有變更
    if (this.originalLawsData.has(law.law_id)) {
      const originalData = this.originalLawsData.get(law.law_id);
      if (originalData && originalData.law_hierarchy !== law.law_hierarchy) {
        this.markLawAsModified(law.id);
      }
    } else {
      // 若沒有原始資料參照，直接標記為已修改
      this.markLawAsModified(law.id);
    }

    // 退出編輯模式
    law.isEditingHierarchy = false;
  }

  // 清除所有法條
  removeAllArticles(): void {
    if (!this.selectedLaw) {
      return;
    }

    // 準備API參數
    const params = {
      companyid: this.companyId,
      topic: this.selectedTopic,
      law_name: this.selectedLaw.law_name,
      type: this.selectedLaw.type,
    };

    this.http
      .post(`${this.apiUrl}/api/law_database/removeArticles`, params)
      .subscribe({
        next: (response: any) => {
          console.log('法條清除成功', response);

          // 清空法條列表
          this.selectedLawArticles = [];

          // 更新主法規列表中的法條數量
          if (this.selectedLaw && this.filteredLaws) {
            const lawInList = this.filteredLaws.find(
              (law) => law.law_id === this.selectedLaw?.law_id
            );

            if (lawInList) {
              lawInList.articleCount = 0;
              lawInList.law_articles = [];
            }
          }

          // 顯示成功訊息
          alert('法條已成功清除');
        },
        error: (error) => {
          console.error('清除法條時發生錯誤', error);
          alert('清除法條時發生錯誤: ' + (error.message || '未知錯誤'));
        },
        complete: () => {
          // 操作完成時的處理 (可選)
          console.log('清除法條請求完成');
        },
      });
  }

  // 進入編輯模式時同步資料
  public toggleArticleEditMode(): void {
    this.isArticleEditMode = !this.isArticleEditMode;
    if (this.isArticleEditMode) {
      // 進入編輯模式時預設採用 JSON 模式，並同步法條資料至兩個模式
      const articlesJson = JSON.stringify(this.selectedLawArticles, null, 2);
      this.articlesJsonText = articlesJson;
      try {
        this.editableArticles = JSON.parse(articlesJson);
      } catch (e) {
        this.editableArticles = [];
      }
      this.isJsonEditMode = false;
      this.isFormDataChanged = false;
      this.jsonError = null;
    } else {
      // 離開編輯模式時，可做儲存或提示
      if (this.isArticlesModified && confirm('尚有未儲存變更，是否要儲存？')) {
        this.saveArticleChanges();
      }
    }
  }

  // Validate and update articles from JSON text
  validateAndUpdateArticles(): void {
    try {
      const parsedArticles = JSON.parse(this.articlesJsonText);
      if (Array.isArray(parsedArticles)) {
        this.selectedLawArticles = parsedArticles;
        this.jsonError = null;
      } else {
        this.jsonError = '必須是陣列格式';
      }
    } catch (error: unknown) {
      // Properly type the caught error
      this.jsonError = error instanceof Error ? error.message : String(error);
    }
  }

  // Handle JSON text changes
  onArticlesJsonChanged(): void {
    this.isArticlesModified = true;
    try {
      JSON.parse(this.articlesJsonText);
      this.jsonError = null;
    } catch (error: unknown) {
      // Properly type the caught error
      this.jsonError = error instanceof Error ? error.message : String(error);
    }
  }

  // PDF upload dialog methods
  openPdfUploadDialog(): void {
    this.showPdfUploadDialog = true;
    this.pdfFile = null;
    this.pdfUploadStatus = '';
    this.isPdfProcessing = false;
    this.pdfProcessSuccess = false;
  }

  closePdfUploadDialog(): void {
    if (this.isPdfProcessing) {
      return; // Prevent closing while processing
    }
    this.showPdfUploadDialog = false;
  }

  onPdfDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onPdfDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onPdfFileDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files.length) {
      const file = event.dataTransfer.files[0];
      if (file.type === 'application/pdf') {
        this.pdfFile = file;
      } else {
        this.pdfUploadStatus = '請上傳 PDF 格式的檔案';
        this.pdfProcessSuccess = false;
      }
    }
  }

  onPdfFileSelected(event: any): void {
    const file = event.target.files[0];
    if (file && file.type === 'application/pdf') {
      this.pdfFile = file;
    } else if (file) {
      this.pdfUploadStatus = '請上傳 PDF 格式的檔案';
      this.pdfProcessSuccess = false;
    }
  }

  removePdfFile(): void {
    this.pdfFile = null;
    this.pdfUploadStatus = '';
  }

  // Upload and parse PDF file
  uploadPdfForParsing(): void {
    if (!this.pdfFile) {
      this.pdfUploadStatus = '請先選擇 PDF 檔案';
      this.pdfProcessSuccess = false;
      return;
    }

    this.isPdfProcessing = true;
    this.pdfUploadStatus = '正在上傳和解析檔案...';

    const formData = new FormData();
    formData.append('pdfFile', this.pdfFile);
    formData.append('lawName', this.selectedLaw?.law_name || '');
    formData.append('model_version', this.pdfModelVersion);

    this.http
      .post<any>(`${this.apiUrl}/api/lawParser/parsePdfLaw`, formData)
      .pipe(
        finalize(() => {
          this.isPdfProcessing = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (response && response.laws && response.laws.law_articles) {
            // Update the articles
            this.selectedLawArticles = response.laws.law_articles;

            // Update the JSON text if in edit mode
            if (this.isArticleEditMode) {
              this.articlesJsonText = JSON.stringify(
                this.selectedLawArticles,
                null,
                2
              );
            }

            // Mark as modified
            this.isArticlesModified = true;

            // Update status
            this.pdfUploadStatus = `成功解析 ${this.selectedLawArticles.length} 條法條`;
            this.pdfProcessSuccess = true;
          } else {
            this.pdfUploadStatus = '解析結果格式不正確';
            this.pdfProcessSuccess = false;
          }
        },
        error: (err) => {
          console.error('PDF 解析錯誤', err);
          this.pdfUploadStatus = `解析失敗: ${
            err.error?.message || err.message || '未知錯誤'
          }`;
          this.pdfProcessSuccess = false;
        },
      });
  }

  // Text parsing dialog methods
  openTextParseDialog(): void {
    this.showTextParseDialog = true;
    this.lawTextInput = '';
    this.textParseStatus = '';
    this.isTextProcessing = false;
    this.textProcessSuccess = false;
  }

  closeTextParseDialog(): void {
    if (this.isTextProcessing) {
      return; // Prevent closing while processing
    }
    this.showTextParseDialog = false;
  }

  // Parse law text
  parseLawText(): void {
    if (!this.lawTextInput || this.lawTextInput.trim().length < 10) {
      this.textParseStatus = '請輸入至少 10 個字的法規文本';
      this.textProcessSuccess = false;
      return;
    }

    this.isTextProcessing = true;
    this.textParseStatus = '正在解析法規文本...';

    const payload = {
      lawText: this.lawTextInput,
      lawName: this.selectedLaw?.law_name || '',
      model_version: this.textModelVersion,
    };

    this.http
      .post<LawTextParseResponse>(
        `${this.apiUrl}/api/lawParser/parseLawText`,
        payload
      )
      .pipe(
        finalize(() => {
          this.isTextProcessing = false;
        })
      )
      .subscribe({
        next: (response) => {
          if (
            response &&
            response.success &&
            response.laws &&
            response.laws.law_articles
          ) {
            // Update the articles
            this.selectedLawArticles = response.laws.law_articles;

            // Update the JSON text if in edit mode
            if (this.isArticleEditMode) {
              this.articlesJsonText = JSON.stringify(
                this.selectedLawArticles,
                null,
                2
              );
            }

            // Mark as modified
            this.isArticlesModified = true;

            // Update status
            this.textParseStatus = `成功解析 ${this.selectedLawArticles.length} 條法條`;
            this.textProcessSuccess = true;

            // Close dialog after short delay
            setTimeout(() => {
              this.closeTextParseDialog();
            }, 1500);
          } else {
            this.textParseStatus = '解析結果格式不正確';
            this.textProcessSuccess = false;
          }
        },
        error: (err) => {
          console.error('文本解析錯誤', err);
          this.textParseStatus = `解析失敗: ${
            err.error?.message || err.message || '未知錯誤'
          }`;
          this.textProcessSuccess = false;
        },
      });
  }

  // Save article changes to database
  saveArticleChanges(): void {
    //將變更的資料同步到json
    this.applyArticleChanges();

    if (this.jsonError) {
      alert('請先修正 JSON 格式錯誤');
      return;
    }

    // Validate JSON if in edit mode
    if (this.isArticleEditMode) {
      this.validateAndUpdateArticles();
      if (this.jsonError) {
        return;
      }
    }

    // 準備 payload，合併 selectedLaw 的所有資料並更新 articles
    const updatedLaw = {
      companyid: this.companyId,
      topic: this.selectedLaw.topic || this.selectedTopic,
      type: this.selectedLaw.type,
      id: this.selectedLaw.id,
      laws: {
        law_id: this.selectedLaw.law_id,
        law_source: this.selectedLaw.law_source,
        law_url: this.selectedLaw.law_url,
        law_key: this.selectedLaw.law_key,
        law_code: this.selectedLaw.law_code,
        law_name: this.selectedLaw.law_name,
        law_publish_date: this.selectedLaw.law_publish_date,
        law_modified_date: this.selectedLaw.law_modified_date,
        law_modifytype: this.selectedLaw.law_modifytype,
        law_version: this.selectedLaw.law_version,
        law_category: this.selectedLaw.law_category,
        law_hierarchy: this.selectedLaw.law_hierarchy,
        law_change_history: this.selectedLaw.law_change_history,
        law_remarks: this.selectedLaw.law_remarks,
        law_tags: this.selectedLaw.law_tags,
        results: this.selectedLaw.results,
        addedToListDate: this.selectedLaw.addedToListDate,
        updatedBy: this.selectedLaw.updatedBy,
        updatedDate: this.selectedLaw.updatedDate,
        law_articles: this.selectedLawArticles, // 用目前最新的條文內容
      },
    };

    console.log('更新的法條', updatedLaw);

    // 取得 id（通常是 law_id 或 _id，請依你的資料結構調整）
    const lawId = this.selectedLaw?.id;
    if (!lawId) {
      alert('找不到法規 ID，無法儲存');
      return;
    }

    // 顯示儲存中狀態
    const tempStatus = this.isArticleEditMode ? this.jsonError : null;
    this.isArticleEditMode ? (this.jsonError = '儲存中...') : null;

    // 呼叫 API
    this.http
      .put<any>(`${this.apiUrl}/api/regulation/update/${lawId}`, updatedLaw)
      .subscribe({
        next: (response) => {
          if (response && response.success) {
            alert('法規資料更新成功');
            this.isArticlesModified = false;
            // 1. 更新彈窗內的法條內容
            if (this.selectedLaw) {
              this.selectedLaw.law_articles = [...this.selectedLawArticles];
              this.selectedLaw.articleCount = this.selectedLawArticles.length;
            }

            // 2. 更新主列表(filteredLaws)的法條內容
            const lawInList = this.filteredLaws.find(
              (law) => law.id === this.selectedLaw?.id
            );
            if (lawInList) {
              lawInList.law_articles = [...this.selectedLawArticles];
              lawInList.articleCount = this.selectedLawArticles.length;
            }
          } else {
            alert(`更新失敗: ${response.message || '未知錯誤'}`);
            this.isArticleEditMode ? (this.jsonError = tempStatus) : null;
          }
        },
        error: (err) => {
          console.error('更新法條錯誤', err);
          alert(`更新失敗: ${err.error?.message || err.message || '未知錯誤'}`);
          this.isArticleEditMode ? (this.jsonError = tempStatus) : null;
        },
      });
  }

  // Confirm removal of all articles
  confirmRemoveAllArticles(): void {
    if (confirm('確定要清除所有法條嗎？此動作無法復原。')) {
      this.editableArticles = [];
      this.selectedLawArticles = [];

      if (this.isArticleEditMode) {
        this.articlesJsonText = '[]';
      }

      this.isFormDataChanged = true;
      this.isArticlesModified = true;
    }
  }

  confirmDeleteSelectedLaws(): void {
    const selectedCount = this.getSelectedLawsCount();
    if (!selectedCount) return;

    // 顯示確認對話框
    const confirmMessage =
      selectedCount === 1
        ? '確定要刪除選中的法規嗎？'
        : `確定要刪除選中的 ${selectedCount} 筆法規嗎？`;

    if (confirm(confirmMessage)) {
      this.deleteSelectedLaws();
    }
  }

  /**
   * 刪除選中的法規
   */
  deleteSelectedLaws(): void {
    // 獲取選中的法規
    const selectedLaws = this.filteredLaws.filter((law) => law.selected);
    if (selectedLaws.length === 0) return;

    // 顯示刪除中訊息
    const loadingMessage = document.createElement('div');
    loadingMessage.className = 'delete-loading-overlay';
    loadingMessage.innerHTML = `<div class="delete-loading-content">
    <i class="fa-solid fa-spinner fa-spin"></i>
    <p>正在刪除中，請稍候...</p>
  </div>`;
    document.body.appendChild(loadingMessage);

    // 追蹤成功和失敗的計數
    let successCount = 0;
    let failureCount = 0;
    let totalCount = selectedLaws.length;
    let completedCount = 0;

    // 對每個選中的法規發送刪除請求
    selectedLaws.forEach((law) => {
      const deleteData = {
        id: law.id,
        companyid: this.companyId,
      };

      this.http
        .post(`${this.apiUrl}/api/regulation/delete_law`, deleteData)
        .subscribe({
          next: (response: any) => {
            if (response && response.success) {
              console.log(`成功刪除法規: ${law.law_name}`);
              successCount++;
            } else {
              console.error(`刪除法規失敗: ${law.law_name}`, response);
              failureCount++;
            }
          },
          error: (error) => {
            console.error(`刪除法規時發生錯誤: ${law.law_name}`, error);
            failureCount++;
          },
          complete: () => {
            completedCount++;

            // 當所有請求完成時，更新UI並顯示結果
            if (completedCount === totalCount) {
              // 移除加載訊息
              document.body.removeChild(loadingMessage);

              // 顯示結果消息
              if (successCount > 0 && failureCount === 0) {
                alert(`成功刪除 ${successCount} 筆法規`);
              } else if (successCount > 0 && failureCount > 0) {
                alert(
                  `成功刪除 ${successCount} 筆法規，但有 ${failureCount} 筆法規刪除失敗`
                );
              } else {
                alert(`刪除失敗，請稍後再試`);
              }

              // 重新載入法規列表
              this.loadRegulations();
            }
          },
        });
    });
  }

  // 切換編輯模式，傳入 true 跳至 JSON 編輯，false 則進入表單模式
  public toggleEditMode(useJson: boolean): void {
    //直接套用變更
    this.applyArticleChanges();

    if (this.isJsonEditMode === useJson) return;

    if (!useJson) {
      // 從 JSON 模式切換到表單模式—先解析 JSON 內容
      try {
        this.editableArticles = JSON.parse(this.articlesJsonText || '[]');
      } catch (e) {
        alert('JSON 格式有誤，請先修正再切換至表單模式。');
        return;
      }
    } else {
      // 從表單模式切換到 JSON 模式—先同步表單資料到 JSON 文本
      try {
        this.articlesJsonText = JSON.stringify(this.editableArticles, null, 2);
      } catch (e) {
        console.error('轉換失敗', e);
      }
    }
    this.isJsonEditMode = useJson;
  }

  // 新增法條（文章）至表單模式中
  addNewArticle(): void {
    this.editableArticles.push({
      article_type: 'A',
      article_no: `第${this.editableArticles.length + 1}條`,
      article_content: '',
      article_index: this.editableArticles.length + 1,
      isNew: true,
    });
    this.isFormDataChanged = true;
  }

  // 新增章節至表單模式中
  addNewChapter(): void {
    this.editableArticles.push({
      article_type: 'C',
      article_content: '新章節標題',
      article_index: this.editableArticles.length + 1,
      isNew: true,
    });
    this.isFormDataChanged = true;
  }

  // 刪除法條／章節
  deleteArticle(index: number): void {
    if (confirm('確定要刪除此項嗎？')) {
      this.editableArticles.splice(index, 1);
      this.isFormDataChanged = true;
    }
  }

  // 表單模式套用變更：更新 JSON 編輯內容並觸發格式驗證
  public applyArticleChanges(): void {
    try {
      this.articlesJsonText = JSON.stringify(this.editableArticles, null, 2);
      this.onArticlesJsonChanged();
    } catch (e) {
      alert('套用變更時發生錯誤');
    }
  }

  dropArticle(event: CdkDragDrop<any[]>): void {
    moveItemInArray(
      this.editableArticles,
      event.previousIndex,
      event.currentIndex
    );
    this.isFormDataChanged = true;
  }

  addNewArticleBelow(index: number): void {
    this.editableArticles.splice(index + 1, 0, {
      article_type: 'A',
      article_no: `第${this.editableArticles.length + 1}條`,
      article_content: '',
      article_index: index + 2,
    });
    this.isFormDataChanged = true;
  }

  get chapterCount(): number {
    return this.editableArticles.filter((a) => a.article_type === 'C').length;
  }

  get articleCount(): number {
    return this.editableArticles.filter((a) => a.article_type === 'A').length;
  }

  syncArticlesToJson(): void {
    this.articlesJsonText = JSON.stringify(this.editableArticles, null, 2);
    this.isFormDataChanged = true;
  }

  // 條次或內容有變更時
  onArticleChanged(index: number, field: 'no' | 'content'): void {
    if (field === 'no') {
      this.editableArticles[index].isNoEdited = true;
    }
    if (field === 'content') {
      this.editableArticles[index].isContentEdited = true;
    }
    this.isFormDataChanged = true;
    this.syncArticlesToJson();
  }

  removeInvolvedDepartment(index: number): void {
    this.involvedDepartments.splice(index, 1);
    this.involvedDepartmentCount = this.involvedDepartments.length;
  }

  /**
   * 批次載入法條內容
   */
  batchLoadLawContents(): void {
    // 找出所有需要載入法條的法規
    const lawsToLoad = this.filteredLaws.filter(
      (law) => !law.articleCount || law.articleCount === 0 || law.loadFailed
    );

    if (lawsToLoad.length === 0) {
      alert('目前所有法規都已有法條內容，無需批次載入。');
      return;
    }

    // 確認是否要批次載入
    if (
      confirm(
        `已找到 ${lawsToLoad.length} 筆法規需要載入法條內容，是否要開始批次載入？\n\n注意: 此過程可能需要較長時間，請勿關閉視窗。`
      )
    ) {
      this.startBatchLoading(lawsToLoad, () => {
        // 完成後回調，重新計算
        this.calculateLawsNeedingContent();
      });
    }
  }

  /**
   * 開始批次載入法條內容
   */
  private startBatchLoading(laws: any[], callback?: () => void): void {
    // 複製一份法規陣列，以免影響原始陣列
    const lawsQueue = [...laws];
    let processedCount = 0;
    const totalCount = lawsQueue.length;

    // 開始逐個載入
    const processNext = () => {
      if (lawsQueue.length > 0) {
        const law = lawsQueue.shift();
        processedCount++;
        // 更新進度
        const progressPercentage = (processedCount / totalCount) * 100;

        // 啟動法條載入
        this.fetchLawContent(law);

        // 一秒後處理下一個
        setTimeout(() => {
          // 使用Azure最佳實踐，使用Promise來處理非同步操作
          Promise.resolve().then(() => processNext());
        }, 1000);
      } else {
        // 全部完成
        alert(`批次載入已完成，共處理 ${processedCount} 筆法規資料。`);

        // 呼叫完成回調（如果有提供）
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    };

    // 啟動處理
    processNext();
  }
  calculateLawsNeedingContent(): void {
    // 根據 Azure 最佳實踐，避免在單個函數中執行過多計算
    // 僅檢查是否沒有法條或載入失敗的法規
    if (!this.filteredLaws) {
      this.lawsNeedingContentCount = 0;
      return;
    }

    this.lawsNeedingContentCount = this.filteredLaws.filter(
      (law) => !law.articleCount || law.articleCount === 0 || law.loadFailed
    ).length;

    // 效能監控日誌 (僅在開發模式)
    if (!environment.production) {
      console.log(`找到 ${this.lawsNeedingContentCount} 筆需要載入法條的法規`);
    }
  }


  /**
   * 檢查法規異動狀況
   * 用於檢查和顯示法規是否有更新或變動
   */
  /**
   * 檢查法規異動狀況（每隔一秒依序檢查每一筆，模擬 API）
   */
   checkLawsChanges(): void {
    // 找出所有需要載入法條的法規
    const lawsToLoad = this.filteredLaws;

    // 確認是否要批次載入
    if (
      confirm(
        `即將開始進行 ${lawsToLoad.length} 筆法規的異動掃描，是否要開始執行？\n\n注意: 此過程可能需要較長時間，請勿關閉視窗。`
      )
    ) {
      this.startBatchScan(lawsToLoad, () => {

      });
    }
  }

    private startBatchScan(laws: any[], callback?: () => void): void {
    // 複製一份法規陣列，以免影響原始陣列
    const lawsQueue = [...laws];
    let processedCount = 0;
    const totalCount = lawsQueue.length;

    // 開始逐個載入
    const processNext = () => {
      if (lawsQueue.length > 0) {
        const law = lawsQueue.shift();
        processedCount++;
        // 更新進度
        const progressPercentage = (processedCount / totalCount) * 100;

        // 啟動法條載入
        this.ScanLawContent(law);

        // 一秒後處理下一個
        setTimeout(() => {
          // 使用Azure最佳實踐，使用Promise來處理非同步操作
          Promise.resolve().then(() => processNext());
        }, 500);
      } else {
        // 全部完成
        alert(`批次載入已完成，共掃描 ${processedCount} 筆法規資料。`);

        // 呼叫完成回調（如果有提供）
        if (callback && typeof callback === 'function') {
          callback();
        }
      }
    };

    // 啟動處理
    processNext();
  }


  //掃描法規的異動日期
    ScanLawContent(law: any): void {
    // 設置為載入中狀態
    law.isLoading = true;
    law.loadFailed = false;

    // 使用 URLSearchParams 構建查詢參數
    const params = new HttpParams()
      .set('lawurl', law.law_url)
      .set('scanupdate', 'true')
      .set('old_modify_date', law.law_modified_date || '');

    // 發送 GET 請求到後端 API 獲取法條內容
    this.http
      .get<any>(`${this.apiUrl}/api/lawParser/fetchLaw`, { params })
      .subscribe({
        next: (response) => {
          // 請求完成，取消載入狀態
          law.isLoading = false;

          console.log('法條異動日期擷取成功:', response);

          law.ScanResult = response.laws.law_modified_date; // 更新最後檢查日期
          law.ScanDate = this.formatDate(new Date()); //記錄掃描日期

          //將資料寫入資料庫
          this.updateScanResultToDatabase(law);



          // var convertedLaw = this.convertlawstructure_scan_history(response.laws,law.type);

          // console.log('轉換後的法條結構:', convertedLaw);

          // this.InseartLawScanHistory(convertedLaw);

          // if (response && response.laws) {
          //   //如果法規名稱是空白的，但API有取得資料，就更新法規名稱
          //   if (!law.law_name && response.laws.law_name) {
          //     law.law_name = response.laws.law_name;
          //   }



          //   // 確保狀態重置
          //   law.loadFailed = false;


          //   //直接將法條內容，寫回資料庫中
          //   var convertedLaw = this.convertlawstructure(law);


          //   //有抓到法條，才更新進去? 還是都更新呢?
          //   if (convertedLaw.laws.law_articles.length > 0) {
          //     // 調用 API 將法規內容更新至資料庫
              // this.updateLawItemToDatabase(convertedLaw);
          //   } else {
          //     law.loadFailed = true;
          //   }


          // } else {
          //   // 資料無效
          //   law.loadFailed = true;
          // }
        },
        error: (err) => {
          // 請求失敗，設置錯誤狀態
          law.isLoading = false;
          law.loadFailed = true;
          console.error('取得法條內容失敗:', err);

          // 更新需要載入的法規數量
          this.calculateLawsNeedingContent();
        },
      });
  }


  updateScanResultToDatabase(law: any): void {
    // 準備請求資料
    const requestData = {
      companyid: this.companyId,
      id: law.id , // 使用 id
      ScanResult: law.ScanResult,
      ScanDate: law.ScanDate
    };

    console.log('更新法規掃描結果:', requestData);

    // 發送 POST 請求到更新掃描結果 API
    this.http
      .post(`${this.apiUrl}/api/regulation/update_scan_result`, requestData)
      .subscribe({
        next: (response: any) => {
          if (response && response.success) {
            console.log('掃描結果更新成功:', response);
            // 可選：更新 UI 顯示
            law.isScanned = true;
          } else {
            console.error('掃描結果更新失敗:', response);
          }
        },
        error: (error) => {
          console.error('更新法規掃描結果失敗:', error);
          // 非關鍵錯誤，不需要彈窗提示，只記錄到控制台
        },
      });
  }


  // 切換顯示/隱藏進階篩選
  toggleAdvancedFilters(): void {
    this.showAdvancedFilters = !this.showAdvancedFilters;
  }

  // 添加部門篩選
  addDepartmentFilter(applyImmediately: boolean = false): void {
    if (
      this.tempDeptFilter &&
      !this.selectedDepartmentFilters.includes(this.tempDeptFilter)
    ) {
      this.selectedDepartmentFilters.push(this.tempDeptFilter);
      this.tempDeptFilter = '';

      // 只有當 applyImmediately 為 true 時才立即應用篩選
      if (applyImmediately) {
        this.applyFilters();
      }
    }
  }

  // 移除部門篩選
  removeDepartmentFilter(
    dept: string,
    applyImmediately: boolean = false
  ): void {
    this.selectedDepartmentFilters = this.selectedDepartmentFilters.filter(
      (d) => d !== dept
    );

    // 只有當 applyImmediately 為 true 時才立即應用篩選
    if (applyImmediately) {
      this.applyFilters();
    }
  }

  // 重置所有篩選條件
  resetFilters(): void {
    // 重置日期區間篩選
    this.dateRangeFilter = {
      start: null,
      end: null,
    };

    // 重置相關性篩選
    this.relevanceFilter = {
      related: false,
      unrelated: false,
      reference: false,
    };

    // 清空部門篩選
    this.selectedDepartmentFilters = [];
    this.tempDeptFilter = '';

    // 如果有其他篩選條件也一併重置

    // 重新載入原始法規列表 (不帶篩選條件)
    this.filteredLaws = [...this.allLaws];

    // 或者如果您的原始法規列表儲存在 filteredLaws 以外的變數 (如 allLaws)
    // this.filteredLaws = [...this.allLaws];

    // 可選: 顯示重置成功的訊息
    console.log('已重置所有篩選條件');
  }
  // 套用所有篩選條件
  applyFilters(): void {
    // 創建一個未過濾的法規列表副本
    let filtered = [...this.allLaws];

    console.log('filtered', filtered);

    // 應用修訂日期篩選
    if (this.dateRangeFilter.start || this.dateRangeFilter.end) {
      filtered = filtered.filter((law) => {
        const lawDate = law.law_modified_date
          ? new Date(law.law_modified_date)
          : null;
        if (!lawDate) return false;

        if (this.dateRangeFilter.start && this.dateRangeFilter.end) {
          const startDate = new Date(this.dateRangeFilter.start);
          const endDate = new Date(this.dateRangeFilter.end);
          return lawDate >= startDate && lawDate <= endDate;
        } else if (this.dateRangeFilter.start) {
          const startDate = new Date(this.dateRangeFilter.start);
          return lawDate >= startDate;
        } else if (this.dateRangeFilter.end) {
          const endDate = new Date(this.dateRangeFilter.end);
          return lawDate <= endDate;
        }

        return true;
      });
    }

    // 應用相關性篩選 - 修正這部分邏輯
    const relevanceSelected =
      this.relevanceFilter.related ||
      this.relevanceFilter.unrelated ||
      this.relevanceFilter.reference;
    if (relevanceSelected) {
      filtered = filtered.filter((law) => {
        // 如果勾選了相關，檢查是否為相關
        if (this.relevanceFilter.related && law.results?.related === 'V')
          return true;

        // 如果勾選了無關，檢查是否為無關
        if (this.relevanceFilter.unrelated && law.results?.unrelated === 'V')
          return true;

        // 如果勾選了參考，檢查是否為參考
        if (this.relevanceFilter.reference && law.results?.reference === 'V')
          return true;

        // 如果上述都不符合，則該法規不符合篩选條件
        return false;
      });
    }

    // 應用部門篩選
    if (this.selectedDepartmentFilters.length > 0) {
      filtered = filtered.filter((law) => {
        const lawDepts = this.ensureArray(law.law_tags);
        return this.selectedDepartmentFilters.some((dept) =>
          lawDepts.includes(dept)
        );
      });
    }

    // 更新顯示的法規列表
    this.filteredLaws = filtered;
  }

  // 在 ngOnInit 或加載數據後收集所有可用部門
  loadAvailableDepartments(): void {
    const deptSet = new Set<string>();
    this.filteredLaws.forEach((law) => {
      const lawDepts = this.ensureArray(law.law_tags);
      lawDepts.forEach((dept) => {
        if (dept) deptSet.add(dept);
      });
    });
    this.availableDepartments = Array.from(deptSet).sort();
  }

  toggleRelevanceDropdown(event: Event) {
    event.stopPropagation();
    this.showRelevanceDropdown = !this.showRelevanceDropdown;
    this.showDepartmentDropdown = false;
  }

  // 切換部門下拉選單顯示狀態
  toggleDepartmentDropdown(event: Event) {
    event.stopPropagation();
    this.showDepartmentDropdown = !this.showDepartmentDropdown;
    this.showRelevanceDropdown = false;
    this.filterDepartments();
  }

  // 處理部門下拉選單失焦事件
  onDepartmentDropdownBlur() {
    // 延遲關閉以允許點擊下拉選單內的選項
    setTimeout(() => {
      this.showDepartmentDropdown = false;
    }, 150);
  }

  // 過濾部門列表
  filterDepartments() {
    if (!this.departmentSearchText) {
      this.filteredDepartments = [...this.availableDepartments];
    } else {
      const searchText = this.departmentSearchText.toLowerCase();
      this.filteredDepartments = this.availableDepartments.filter((dept) =>
        dept.toLowerCase().includes(searchText)
      );
    }
  }

  // 檢查部門是否已選擇
  isDepartmentSelected(dept: string): boolean {
    return this.selectedDepartmentFilters.includes(dept);
  }

  // 切換部門選擇狀態
  toggleDepartmentSelection(dept: string) {
    if (this.isDepartmentSelected(dept)) {
      this.removeDepartmentFilter(dept, false);
    } else {
      this.selectedDepartmentFilters.push(dept);
    }
  }

  // 檢查是否全選
  isAllDepartmentsSelected(): boolean {
    return this.filteredDepartments.length > 0 &&
           this.selectedDepartmentFilters.length === this.filteredDepartments.length &&
           this.filteredDepartments.every(dept => this.selectedDepartmentFilters.includes(dept));
  }

  // 切換全選狀態
  toggleAllDepartmentSelection(): void {
    if (this.isAllDepartmentsSelected()) {
      // 取消全選：移除所有當前篩選顯示的標籤
      this.filteredDepartments.forEach(dept => {
        if (this.selectedDepartmentFilters.includes(dept)) {
          this.removeDepartmentFilter(dept, false);
        }
      });
    } else {
      // 全選：添加所有當前篩選顯示的標籤
      this.filteredDepartments.forEach(dept => {
        if (!this.selectedDepartmentFilters.includes(dept)) {
          this.selectedDepartmentFilters.push(dept);
        }
      });
    }
  }

  // 獲取已選擇的相關性數量
  getSelectedRelevanceCount(): number {
    let count = 0;
    if (this.relevanceFilter.related) count++;
    if (this.relevanceFilter.unrelated) count++;
    if (this.relevanceFilter.reference) count++;
    return count;
  }

  onLawFieldTouched(field: LawFieldKey) {
    this.isLawFieldTouched[field] = true;
    this.isFormDataChanged = true;
  }



  /**
   * 將 Date 物件格式化為 yyyy-mm-dd 格式的字串
   */
  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  // 切換「編輯清單」下拉選單
  toggleEditListDropdown(event: Event): void {
    event.stopPropagation();
    this.showEditListDropdown = !this.showEditListDropdown;
    // 關閉其他下拉
    this.showImportDropdown = false;
    this.showBatchDropdown = false;
  }

  // 開啟/關閉編輯主題名稱 Dialog
  openEditTopicDialog(): void {
    this.showEditTopicDialog = true;
    this.showEditListDropdown = false;
    // 只顯示目前選擇的主題
    this.currentTopicName = this.selectedTopic || '';
    this.newTopicName = '';
  }
  closeEditTopicDialog(): void {
    this.showEditTopicDialog = false;
  }

  // 開啟/關閉刪除主題 Dialog
  openDeleteTopicDialog(): void {
    this.showDeleteTopicDialog = true;
    this.showEditListDropdown = false;
    // 只顯示目前選擇的主題
    this.topicToDelete = this.selectedTopic || '';
    this.confirmDeleteText = '';
  }
  closeDeleteTopicDialog(): void {
    this.showDeleteTopicDialog = false;
  }

  // 編輯主題名稱確認
  updateTopicName(): void {
    if (!this.currentTopicName || !this.newTopicName) {
      alert('請選擇目前主題並輸入新主題名稱');
      return;
    }
    this.isUpdatingTopic = true;
    const payload = {
      companyid: this.companyId,
      topic: this.currentTopicName,
      newtopic: this.newTopicName,
    };
    this.http
      .post<any>(`${this.apiUrl}/api/law_database/update_topic_name`, payload)
      .pipe(
        finalize(() => {
          this.isUpdatingTopic = false;
        })
      )
      .subscribe({
        next: (res) => {
          if (res && res.success) {
            alert(
              `主題「${this.currentTopicName}」已成功更名為「${this.newTopicName}」`
            );
            this.loadAllTopics();
            this.closeEditTopicDialog();
          } else {
            alert(res?.message || '主題更名失敗');
          }
        },
        error: (err) => {
          alert(
            '主題更名時發生錯誤: ' + (err?.error?.message || err.message || err)
          );
        },
      });
  }

  // 刪除主題確認
  deleteTopic(): void {
    if (!this.topicToDelete || this.confirmDeleteText !== this.topicToDelete) {
      alert('請正確輸入主題名稱以確認刪除');
      return;
    }
    this.isDeletingTopic = true;
    const payload = {
      companyid: this.companyId,
      topic: this.topicToDelete,
    };
    this.http
      .post<any>(`${this.apiUrl}/api/law_database/delete_topic`, payload)
      .pipe(
        finalize(() => {
          this.isDeletingTopic = false;
        })
      )
      .subscribe({
        next: (res) => {
          if (res && res.success) {
            alert(`主題「${this.topicToDelete}」已成功刪除`);
            this.loadAllTopics();
            this.closeDeleteTopicDialog();
          } else {
            alert(res?.message || '主題刪除失敗');
          }
        },
        error: (err) => {
          alert(
            '主題刪除時發生錯誤: ' + (err?.error?.message || err.message || err)
          );
        },
      });
  }

  isDateNewer(ScanResult: string, law_modified_date: string | number): boolean {
    if (!ScanResult || !law_modified_date) return false;

    // 轉換為日期對象進行比較
    const checkedDate = new Date(ScanResult);
    const modifiedDate = typeof law_modified_date === 'number'
      ? new Date(law_modified_date)
      : new Date(law_modified_date);

    // 如果任一日期無效，返回 false
    if (isNaN(checkedDate.getTime()) || isNaN(modifiedDate.getTime())) return false;

    // 比較日期，如果 ScanResult 比 law_modified_date 新，則返回 true
    return checkedDate.getTime() > modifiedDate.getTime();
  }

  /**
   * 是否有任何異動檢查結果（即有 ScanResult）
   */
  hasCheckedChangeResults(): boolean {
    return this.filteredLaws?.some((law) => !!law.ScanResult);
  }

  saveExcelDataToDatabase(): void {
    if (!this.excelconveterresult || this.excelconveterresult.length === 0) {
      this.showErrorMessage('沒有可匯入的資料');
      return;
    }

    // 顯示匯入中狀態
    this.importStatus = '正在匯入資料到資料庫...';
    this.isImporting = true;

    // 直接將物件陣列送到 API，不要轉成字串
    this.http
      .post(`${this.apiUrl}/api/regulation/import_data_to_law_list`, this.excelconveterresult)
      .subscribe({
        next: (response: any) => {
          this.isImporting = false;
          if (response && response.success) {
            this.importStatus = '資料已成功匯入資料庫';
            this.showSuccessMessage('資料已成功匯入資料庫');
          } else {
            this.importStatus = '匯入失敗: ' + (response?.message || '未知錯誤');
            this.showErrorMessage(this.importStatus);
          }
        },
        error: (error) => {
          this.isImporting = false;
          this.importStatus = '匯入失敗: ' + (error?.error?.message || error.message || '網路錯誤');
          this.showErrorMessage(this.importStatus);
        }
      });
  }

  regulationUpdate(law: any) {
    console.log(law);

    // 設定要更新的法規並顯示比較元件
    this.currentLawForUpdate = law;
    this.showLawUpdateCompare = true;
  }

  // 關閉法規更新比較元件
  closeLawUpdateCompare() {
    this.showLawUpdateCompare = false;
    this.currentLawForUpdate = null;
  }

  // 確認更新法規
  onLawUpdateConfirmed(updatedLaw: any) {
    // TODO: 實作將更新後的法規儲存到資料庫的邏輯
    console.log('法規更新確認:', updatedLaw);

    // 更新本地資料
    const index = this.filteredLaws.findIndex(law => law.law_name === updatedLaw.law_name);
    if (index !== -1) {
      this.filteredLaws[index] = { ...this.filteredLaws[index], ...updatedLaw };
    }

    // 關閉比較元件
    this.closeLawUpdateCompare();

    // 顯示成功訊息
    alert(this.i18nService.translate('regulation.update.success'));
  }

  /**
   * 相關性下拉選單 blur 時自動收合
   */
  onRelevanceDropdownBlur() {
    this.showRelevanceDropdown = false;
  }

  // 排序功能方法

  /**
   * 處理表頭點擊事件，切換排序狀態
   * @param field 排序欄位
   */
  onSortClick(field: string): void {
    if (this.currentSortField === field) {
      // 同一欄位，切換排序方向
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      // 不同欄位，設定新的排序欄位，預設升冪排序
      this.currentSortField = field;
      this.sortDirection = 'asc';
    }

    // 重新排序並更新顯示
    this.filteredLaws.sort((a, b) => this.sortData(a, b));
  }

  /**
   * 獲取排序指示器的 CSS 類別
   * @param field 欄位名稱
   * @returns CSS 類別字串
   */
  getSortIndicatorClass(field: string): string {
    if (this.currentSortField !== field) {
      return 'sort-indicator'; // 預設狀態
    }

    return this.sortDirection === 'asc'
      ? 'sort-indicator sort-asc'
      : 'sort-indicator sort-desc';
  }

  /**
   * 檢查欄位是否為當前排序欄位
   * @param field 欄位名稱
   * @returns 是否為當前排序欄位
   */
  isCurrentSortField(field: string): boolean {
    return this.currentSortField === field;
  }

  /**
   * 通用排序方法
   * @param a 第一個比較項目
   * @param b 第二個比較項目
   * @returns 排序結果
   */
  sortData(a: any, b: any): number {
    // 如果沒有設定排序欄位，使用預設的法規名稱排序
    const field = this.currentSortField || 'law_name';
    const direction = this.sortDirection === 'desc' ? -1 : 1;

    let valueA = a[field];
    let valueB = b[field];

    // 處理空值
    if (valueA == null) valueA = '';
    if (valueB == null) valueB = '';

    // 根據欄位類型進行不同的排序處理
    switch (field) {
      case 'law_modified_date':
        return this.compareDates(valueA, valueB) * direction;

      case 'relevance':
        return this.compareRelevance(valueA, valueB) * direction;

      case 'law_tags':
        return this.compareTags(valueA, valueB) * direction;

      case 'law_name':
      case 'type':
      case 'law_hierarchy':
      default:
        return this.compareStrings(valueA, valueB) * direction;
    }
  }

  /**
   * 字串比較（支援中文排序）
   */
  private compareStrings(a: string, b: string): number {
    const strA = String(a || '');
    const strB = String(b || '');
    return strA.localeCompare(strB, 'zh-TW');
  }

  /**
   * 日期比較
   */
  private compareDates(a: string, b: string): number {
    const dateA = a ? new Date(a).getTime() : 0;
    const dateB = b ? new Date(b).getTime() : 0;
    return dateA - dateB;
  }

  /**
   * 相關性比較（相關 > 參考 > 無關）
   */
  private compareRelevance(a: string, b: string): number {
    const relevanceOrder: { [key: string]: number } = {
      '相關': 3,
      '參考': 2,
      '無關': 1,
      '': 0
    };

    const valueA = relevanceOrder[a] || 0;
    const valueB = relevanceOrder[b] || 0;
    return valueA - valueB;
  }

  /**
   * 標籤比較（按標籤數量和字母順序）
   */
  private compareTags(a: any, b: any): number {
    const tagsA = Array.isArray(a) ? a : [];
    const tagsB = Array.isArray(b) ? b : [];

    // 先按標籤數量排序
    const countDiff = tagsA.length - tagsB.length;
    if (countDiff !== 0) {
      return countDiff;
    }

    // 如果標籤數量相同，按第一個標籤的字母順序排序
    const firstTagA = tagsA[0] || '';
    const firstTagB = tagsB[0] || '';
    return this.compareStrings(firstTagA, firstTagB);
  }

  /**
   * 載入部門成員資料
   * @param departmentId 部門ID
   */
  private loadDepartmentMembers(departmentId: string): void {
    // 如果已經有快取資料，不重複載入
    if (this.departmentMembersCache[departmentId]) {
      return;
    }

    // 如果正在載入中，不重複請求
    if (this.loadingDepartmentMembers.has(departmentId)) {
      return;
    }

    // 標記為載入中
    this.loadingDepartmentMembers.add(departmentId);

    const params = new HttpParams()
      .set('companyid', this.companyId)
      .set('assistantNo', this.assistantNo)
      .set('departmentId', departmentId);

    this.http
      .get<any>(`${this.apiUrl}/api/departments/members`, { params })
      .subscribe({
        next: (response) => {
          if (response.success && response.data) {
            // 儲存到快取
            this.departmentMembersCache[departmentId] = response.data[departmentId] || [];
          }
          this.loadingDepartmentMembers.delete(departmentId);
        },
        error: (error) => {
          console.error('載入部門成員失敗:', error);
          this.departmentMembersCache[departmentId] = [];
          this.loadingDepartmentMembers.delete(departmentId);
        }
      });
  }

  /**
   * 取得部門成員資訊摘要
   * @param departmentId 部門ID
   * @returns 成員資訊摘要文字
   */
  getDepartmentMembersSummary(departmentId: string): string {
    const members = this.departmentMembersCache[departmentId];

    if (this.loadingDepartmentMembers.has(departmentId)) {
      return '載入中...';
    }

    if (!members || members.length === 0) {
      return '無成員資料';
    }

    // 建立包含名稱和 email 的成員資訊
    const memberInfo = members.map(m => {
      if (m.email) {
        return `${m.name} (${m.email})`;
      }
      return m.name;
    }).join('、');
    
    return `共 ${members.length} 人：${memberInfo}`;
  }

  /**
   * 取得部門成員數量
   * @param departmentId 部門ID
   * @returns 成員數量
   */
  getDepartmentMembersCount(departmentId: string): number {
    const members = this.departmentMembersCache[departmentId];
    return members ? members.length : 0;
  }

  /**
   * 取得所有選取群組中有 email 的成員總數
   * @returns 有 email 的成員總數
   */
  getTotalMembersWithEmail(): number {
    let totalCount = 0;
    
    // 遍歷所有選取的群組
    for (const groupId of this.selectedGroups) {
      const members = this.departmentMembersCache[groupId];
      if (members && Array.isArray(members)) {
        // 計算有 email 的成員數量
        const membersWithEmail = members.filter(m => m.email && m.email.trim() !== '');
        totalCount += membersWithEmail.length;
      }
    }
    
    return totalCount;
  }

  /**
   * 取得所有選取群組的 email 清單摘要
   * @returns email 清單摘要文字
   */
  getAllEmailsSummary(): string {
    const emailList: string[] = [];
    
    // 遍歷所有選取的群組
    for (const groupId of this.selectedGroups) {
      const members = this.departmentMembersCache[groupId];
      if (members && Array.isArray(members)) {
        // 收集有 email 的成員資訊
        members.forEach(m => {
          if (m.email && m.email.trim() !== '') {
            emailList.push(`${m.name} (${m.email})`);
          }
        });
      }
    }
    
    if (emailList.length === 0) {
      return '尚無信箱資料';
    }
    
    // 將 email 清單組合成字串，每個信箱換行顯示
    return `將寄送至以下信箱：\n${emailList.join('\n')}`;
  }

}
